import React, { Component } from 'react';
import axios from 'axios';
import { withRouter, Link } from 'react-router-dom';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';
import Modal from 'react-modal';
import "react-accessible-accordion/dist/fancy-example.css";
import ScrollToTop from '../Scroll/ScrollToTop';
import util from 'util';
import DocumentMeta from 'react-document-meta';
import WhiteTicketImg from '../Images/white_ticket.svg';
import Common from '../Common/common';
import WhiteMembershipPassImg from '../Images/white_membershippass.svg';
import WhiteEventImg from '../Images/white_event.svg';
import WhiteMenuImg from '../Images/white_menu.svg'
import MembershipPass from './MembershipPass';
import PointHistory from './PointHistory';
import TicketList from './TicketList';
import TicketPaidList from './TicketPaidList';
import TicketIssueList from './TicketIssueList';
import TicketIssuePaidList from './TicketIssuePaidList';
import Ticket from './Ticket';
import TicketIssue from './TicketIssue';
import CouponList from './CouponList';
import StampCard from './StampCard'
import StampScan from './StampScan'
import Liffconfirm from './Liffconfirm'
import FirstBonus from './FirstBonus';
import RankUp from './RankUp';
import BenefitUse from './BenefitUse';
import BenefitFinish from './BenefitFinish';
import DeliveryBenefitFinish from './DeliveryBenefitFinish';
import AppLottery from './AppLottery';
import EventInfoList from './EventInfoList';
import EventInfo from './EventInfo';
import InputEntry from './InputEntry';
import 'bootstrap-icons/font/bootstrap-icons.css';

Modal.setAppElement("#root");

class Liff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      cssLoaded: false,
      my_order: null,
      ready: false,
      available_point: 0,
      my_customer: {
        mail_address: '',
        gender: '',
        birth: '',
        postal_code: '',
        card_id: '',
        privacy_policy: constClass.FLAG.OFF,
        cancel_cause: '',
        m_coupon_code: []
      },
      original_customer: {},
      campaignlist: null,
      campaign: { campaign_id: '', m_site_card: [] },
      coupon_list: null,
      siteId: isFinite(props.match.params.siteId) ? props.match.params.siteId : 0,
      mallId: isFinite(props.match.params.mallId) ? props.match.params.mallId : 0,
      shopCode: props.match.params.shopCode ? props.match.params.shopCode : 0,
      coupon_code: null,
      popover_message: {},
      message: {
        mail_address: '',
        gender: '',
        birth: '',
        postal_code: '',
        card_id: '',
        phone_number: '',
      },
      copy_message: null,
      user_change: false,
      modal_flag: false,
      pre_modal_flag: false,
      ticket_list: null,
      ticket_issuelist: null,
      benefit_grant_list: null,
      ng_coupon_list: [],
      my_entry: {
        campaign_id: '',
        status: constClass.STATUS.UREG,
        privacy_policy: constClass.FLAG.OFF
      },
      headerHeight: 0,
      footerHeight: 0,
      setting: null,
      mall: null,
      initialQs: null,
      customer_detail_type: [],
      postal_code_flag: false,
      cancel_modal_flag: false,
      menuView: false,
      firstbonus: null,
      applotterybonus: null,
      lottery_flag: false,
      stamp_master_data: null,
      entrytype_master: null,
      order: null,
      order_message: {},
      rankCustomer: false,
    };

    this.modalStyle = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: "rgba(0,0,0,0.5)"
      },
      content: {
        position: "absolute",
        left: '0.5rem',
        right: '0.5rem',
        top: '10vw',
        bottom: 'auto',
        marginTop: '0.5rem',
        borderRadius: "0rem",
        padding: "0px",
        height: "auto"
      }
    };

    this.modalMenuStyle = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 100
      },
      content: {
        position: "absolute",
        left: '0',
        right: '0.5rem',
        top: '0',
        bottom: 'auto',
        borderRadius: "0rem",
        padding: "0px",
        height: "100%",
        width: "100%",
        overflow: "scroll",
        zIndex: 100
      }
    };

    this.handleCssLoad = this.handleCssLoad.bind(this);
    this.getDefaultPage = this.getDefaultPage.bind(this);
    this.historyBack = this.historyBack.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.changeCustomer = this.changeCustomer.bind(this);
    this.changeCustomerDetail = this.changeCustomerDetail.bind(this);
    this.setReady = this.setReady.bind(this);
    this.copyTextToClipboard = this.copyTextToClipboard.bind(this);
    this.resetCustomer = this.resetCustomer.bind(this);
    this.closePostalCode = this.closePostalCode.bind(this);
    this.setPostalCode = this.setPostalCode.bind(this);
    this.pageRef = React.createRef();
    this.intervalPop = [];
    this.headerRef = React.createRef();
    this.footerRef = React.createRef();
    this.stampRef = React.createRef();
  }

  handleCssLoad() {
    this.setState({ cssLoaded: true });
    this.setReady();
  };

  async componentDidMount() {
    // サイト情報取得
    var site = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/site/search/`, { site_id: this.state.siteId })).data;
    this.site_name = site.site_name;
    this.meta = {
      link: {
        rel: {
          icon: `/${this.state.siteId}/favicon.ico`,
          "apple-touch-icon": `/${this.state.siteId}/logo192.png`,
          manifest: `/${this.state.siteId}/manifest.json`,
          stylesheet: `/${this.state.siteId}/style.css`,
        },
      },
      title: site ? site.site_name : '',
      description: site ? site.site_name : '',
    }

    this.refreshData();
    this.disableBounceScroll();
    window.addEventListener('popstate', this.resetCustomer, false);
  }

  componentDidUpdate(prevProps, prevState) {
    const height = { header: prevState.headerHeight, footer: prevState.footerHeight };
    if (this.headerRef.current) {
      const rect = this.headerRef.current.getBoundingClientRect();
      if (height.header !== rect.height) {
        this.setState({ headerHeight: rect.height });
      }
    }
    if (this.footerRef.current) {
      const rect = this.footerRef.current.getBoundingClientRect();
      if (height.footer !== rect.height) {
        this.setState({ footerHeight: rect.height });
      }
    }

    const linkElementNode = document.querySelector(`link[href="/${this.state.siteId}/style.css"]`);
    if (linkElementNode && !linkElementNode.onload) {
      linkElementNode.onload = this.handleCssLoad;
      linkElementNode.onerror = this.handleCssLoad;
    }
  }

  async componentWillUnmount() {
    // clearInterval(this.intervalCount);
    window.removeEventListener('popstate', this.resetCustomer, false);
  }

  disableBounceScroll() {
    let touchY = 0;

    document.body.addEventListener('touchstart', (e) => {
      touchY = e.touches[0].screenY;
    });

    document.body.addEventListener('touchmove', (e) => {
      let el = e.target;
      // let el = this.pageRef.current;// e.targetが機種によって変動するため、pageに固定
      const moveY = e.touches[0].screenY;
      let noScroll = true;

      while (el !== null) {
        if (el.offsetHeight < el.scrollHeight) {
          if (touchY < moveY && el.scrollTop === 0) {
            noScroll = false;
            break;
          }

          if (touchY > moveY && el.scrollTop === el.scrollHeight - el.offsetHeight) {
            noScroll = false;
            break;
          }

          noScroll = false;
          break;
        }
        // console.log(`moveY=${moveY}, touchY=${touchY}, offsetHeight=${el.offsetHeight}, scrollHeight=${el.scrollHeight}, scrollTop=${el.scrollTop}, className=${el.className}, id=${el.id}, ${el.localName}`);
        el = el.parentElement;
      }
      // console.log(`moveY=${moveY}, touchY=${touchY}, offsetHeight=${el.offsetHeight}, scrollHeight=${el.scrollHeight}, scrollTop=${el.scrollTop}, className=${el.className}, id=${el.id}, ${el.localName}`);
      if (noScroll) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }

      touchY = moveY;
    }, { passive: false });
  }

  changeCustomer(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    const my_customer = { ...this.state.my_customer, [name]: value };
    this.setState({
      my_customer
    });

    var message = this.state.message;
    this.setState({
      message: { ...message, [name]: this.validator(name, value, this.state.setting) }
    });
    // console.log(`${name}: ${value}`);
  }

  changeCustomerDetail(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    const detail = [...this.state.my_customer.t_customer_detail];
    Common.setCustomerDetail(detail, name, value);
    const my_customer = { ...this.state.my_customer, t_customer_detail: detail };
    this.setState({
      my_customer
    });
  }

  validator(name, value, setting) {
    switch (name) {
      case 'birth':
        return this.dateValidation(value, setting);
      case 'postal_code':
        return this.postalCodeValidation(value, setting);
      case 'mail_address':
        return this.mailAddressValidation(value, setting);
      case 'card_id':
        return this.cardIdiValidation(value, setting);
      case 'phone_number':
        return this.phoneValidation(value, setting);
      default:
        return '';
    }
  }

  questionvalidator(name, value) {
    switch (name) {
      case 'customer_name':
        return this.requiredValidation(value, 'customer_name');
      case 'customer_kana':
        return this.requiredValidation(value, 'customer_kana');
      case 'customer_gender':
        return this.requiredValidation(value, 'customer_gender');
      case 'customer_birthday':
        return this.dateValidation(value, 'customer_birthday');
      case 'customer_postal_code':
        return this.postalCodeValidation(value, 'customer_postal_code');
      case 'customer_address':
        return this.requiredValidation(value, 'customer_address');
      case 'customer_tel':
        return this.phoneValidation(value, 'customer_tel');
      case 'customer_mail':
        return this.mailaddressValidation(value, 'customer_mail');
      default:
        break;
    }
    switch (name) {
      case 'child_name':
        return this.childnameValidation(value, 'child_name');
      case 'child_kana':
        return this.childnameValidation(value, 'child_kana');
      case 'child_gender':
        return this.requiredValidation(value, 'child_gender');
      case 'child_birthday':
        return this.dateValidation(value, 'child_birthday');
      case 'school_name':
        return this.requiredValidation(value, 'school_name');
      case 'school_year':
        return this.requiredValidation(value, 'school_year');
      default:
        break;
    }
    return '';
  }

  dateValidation(value, setting) {
    if (setting['INPUT_BIRTH'] === constClass.INPUT.ENABLED) return '';
    const date = Common.getDateObject(value);
    const now = new Date();
    const selectedDate = new Date(date.year, date.month - 1, date.date);
    if (setting['INPUT_BIRTH_YEAR'] === constClass.FLAG.ON && !date.year) return '※年を選択してください';
    if (setting['INPUT_BIRTH_MONTH'] === constClass.FLAG.ON && !date.month) return '※月を選択してください';
    if (setting['INPUT_BIRTH_DATE'] === constClass.FLAG.ON && !date.date) return '※日を選択してください';
    if (selectedDate > now) {
      if (date.year > now.getFullYear()) return '※年を選択しなおしてください';
      if (date.month > (now.getMonth() + 1)) return '※月を選択しなおしてください';
      return '※日を選択しなおしてください';
    }
    return '';
  }

  postalCodeValidation(value, setting) {
    if (setting['INPUT_POSTAL_CODE'] === constClass.INPUT.ENABLED && value === '') return '';
    const regex = /^[0-9]{7}$/;
    if (!regex.test(value)) return '※正しい郵便番号を入力してください';
    // 郵便番号による地域チェック
    // const num = Number(value);
    // if (!(8000000 <= num && num <= 8399999) &&
    //   !(8710000 <= num && num <= 8710999) &&
    //   !(8400000 <= num && num <= 8499999) &&
    //   !(8640000 <= num && num <= 8649999) &&
    //   !(8610800 <= num && num <= 8610899) &&
    //   !(8770000 <= num && num <= 8779999) &&
    //   !(7500000 <= num && num <= 7599999)) return '※申し訳ございませんが、本サービスの提供エリア外のご登録となりますので、ご登録いただけません';
    return '';
  }

  mailAddressValidation(value, setting) {
    if (setting['INPUT_MAIL_ADDRESS'] === constClass.INPUT.ENABLED && value === '') return '';
    const regex = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
    if (!regex.test(value)) return '※正しいメールアドレスを入力してください';
    return '';
  }

  cardIdiValidation(value, setting) {
    if (setting['INPUT_CARD_ID'] === constClass.INPUT.ENABLED && value === '') return '';
    const regex = /^[a-zA-Z0-9]{15}$/;
    if (!regex.test(value)) return '※正しい形式でnimoca番号を入力してください';
    return '';
  }

  phoneValidation(value, setting) {
    if (setting['INPUT_PHONE_NUMBER'] === constClass.INPUT.ENABLED && value === '') return '';
    const regex = /^\(?0[0-9\-()]{9,12}$/;
    if (!regex.test(value)) return '※正しい形式で電話番号を入力してください';
    return '';
  }

  scrollPageTop() {
    setTimeout(() => {
      this.pageRef.current.scrollTo(0, 0);
      // window.scrollTo(0, 0);
    }, 1);
  }

  scrollWindowTop() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1);
  }

  searchPostalCode() {
    this.setState({
      postal_code_flag: true
    });
  }

  closePostalCode() {
    this.setState({
      postal_code_flag: false
    });
  }

  setPostalCode(code) {
    const my_customer = { ...this.state.my_customer, postal_code: code };
    this.setState({
      my_customer,
      postal_code_flag: false
    });
  }

  changePage(page) {
    this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${page}`);
    this.setState({ menuView: false });
  }

  async assignCouponCode(my_customer, coupon_list) {
    // クーポンに払い出されていないものがあれば払い出す
    const used_list = my_customer.m_coupon_code.map(c => c.coupon_id);
    // クーポンリストから未使用のクーポンIDを抽出
    const unused_list = coupon_list.filter(c => !used_list.includes(c.coupon_id));
    // 未使用のクーポンがあれば払い出し
    if (unused_list.length > 0) {
      // 未使用のクーポンに空きがないリストを作成し使わせないようにする
      const ng_coupon_list = coupon_list.filter(c => unused_list.includes(c) && c.unused_code_count === 0).map(c => c.coupon_id);
      this.setState({ ng_coupon_list });
      // クーポンごとに払い出して結果を待ち合わせ
      await Promise.all(unused_list.filter(c => !ng_coupon_list.includes(c.coupon_id)).map(async (coupon) => {
        // 検索条件
        const params = {
          customer_id: my_customer.customer_id,
          coupon_month: Common.getMonthString(),
          line_id: this.props.liff_access_token,
          mall_id: this.state.mallId
        };
        try {
          await axios.post(`${process.env.REACT_APP_BACKEND_URL}/coupon_code/line/customer/${this.state.siteId}/${coupon.coupon_id}/`, params);
        } catch (err) {
          console.log(err);
          alert('エラーが発生しました。');
        }
      }));
      const customer_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/search/`, { site_id: this.state.siteId, mall_id: this.state.mallId, line_id: this.props.liff_access_token })).data;
      my_customer = customer_data.find(c => c.line_id === this.props.liff_user_id);
    }
    return my_customer;
  }

  getDefaultPage(setting) {
    // 初期ページ設定
    var page;
    const s = setting ? setting : this.state.setting;
    if (Common.getFunctionEnabled(s, 'MEMBERCARD')) {
      page = constClass.MEMBERSHIPPASS;
    } else if (Common.getFunctionEnabled(s, 'COUPON')) {
      page = constClass.COUPONLIST;
    } else if (Common.getFunctionEnabled(s, 'TICKET')) {
      page = constClass.TICKETLIST;
    } else {
      page = constClass.REGISTRATIONUSER;
    }
    return page;
  }

  historyBack() {
    if (this.props.history.length <= 1) {
      this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${this.getDefaultPage(this.state.setting)}`);
    } else {
      this.props.history.goBack();
    }
  }

  // changeイベント
  changeOrder(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      order: {
        ...this.state.order,
        [name]: value,
      }
    });
  }

  filterAvailableTicketList(ticket_list, over_ticket) {
    return ticket_list.filter(t => {
      if (over_ticket.includes(t.ticket_id)) {
        return false;
      }
      if (t.m_schedule) {
        const sysdate = new Date();
        const currentDay = sysdate.getDay();
        const currentHour = sysdate.getHours();
        const day = parseInt(String(sysdate.getDate()).padStart(2, '0'), 10);
        let isDayValid = null;

        const startTime = t.m_schedule.start_time;
        const endTime = t.m_schedule.end_time;
        const isTimeValid = currentHour >= startTime && currentHour <= endTime;

        if (t.m_schedule.schedule_type === "0") {
          const weekdays = t.m_schedule.weekdays;
          const isWeekdayValid = weekdays.includes(currentDay);
          return isWeekdayValid && isTimeValid;

        } else if (t.m_schedule.schedule_type === "1") {
          const startDate = parseInt(t.m_schedule.start_date, 10);
          const endDate = parseInt(t.m_schedule.end_date, 10);
          if (startDate <= endDate) {
            isDayValid = day >= startDate && day <= endDate;
            return isDayValid && isTimeValid;
          } else {
            isDayValid = day <= endDate || day >= startDate;
            return isDayValid && isTimeValid;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    });
  }

  async ticketBack() {
    const ticket_list = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/line/${this.state.siteId}/list/`, { customer_id: this.state.my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId })).data;
    const ticket_issuelist = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/line/${this.state.siteId}/issuelist/`, { customer_id: this.state.my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId })).data;
    const benefit_lottery_ticket_list = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${this.state.siteId}/issuelist/`, { customer_id: this.state.my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId })).data;
    const ticket_group = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/line/${this.state.siteId}/list/`, { customer_id: this.state.my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId })).data;
    const ticket_count = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/line/${this.state.siteId}/countlist/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId })).data;
    const ticket_issuecount = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/line/${this.state.siteId}/issuecountlist/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId })).data;

    const merged_count = [...ticket_count, ...ticket_issuecount].reduce((acc, item) => {
      if (!acc[item.ticket_id]) {
        acc[item.ticket_id] = { ticket_id: item.ticket_id, count: 0 };
      }
      acc[item.ticket_id].count += Number(item.count) || 0;
      return acc;
    }, {});

    const over_ticket = [];
    ticket_group.forEach(group => {
      if (group.m_ticket_group_ticket) {
        const groupTotalCount = group.m_ticket_group_ticket.reduce((sum, t) => {
          const ticketId = t.ticket_id;
          return sum + (merged_count[ticketId]?.count || 0);
        }, 0);

        if (group.max_usage_count !== null && group.max_usage_count !== undefined && groupTotalCount >= group.max_usage_count) {
          group.m_ticket_group_ticket.forEach(t => {
            over_ticket.push(t.ticket_id);
          });
        }
      }
    });

    const filter_ticket_list = this.filterAvailableTicketList(ticket_list, over_ticket);
    const filter_ticket_issuelist = ticket_issuelist.filter(t => !over_ticket.includes(t.ticket_id));

    this.setState({
      ticket_list: filter_ticket_list,
      ticket_issuelist: filter_ticket_issuelist,
      benefit_lottery_ticket_list
    });
  }

  async refreshData(reload = false) {
    if (process.env.REACT_APP_ENV !== 'dev') {
      await window.liff.ready;
    }
    if (!this.props.liff_access_token) {
      if (!this.intervalMaster) {
        this.intervalMaster = setInterval(() => {
          this.refreshData();
        }, 500);
      }
    } else {
      clearInterval(this.intervalMaster);
      if (!this.state.siteId) { // site未設定
        this.props.history.replace(`/1/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=`); // site一覧からの設定処理？→暫定でリダイレクト TODO:変更を忘れないこと！
        return;
      }
      if (process.env.REACT_APP_ENV !== 'dev' && this.props.liff_access_token === 'token_unusable') { // トークン取得不可→非LINEブラウザ
        window.location.replace(process.env.REACT_APP_LINE_FRIEND); //友だち登録にリダイレクト　TODO:変更必要！
        return;
      }
      // 各種APIコール
      const params = { site_id: this.state.siteId, line_id: this.props.liff_access_token, mall_id: this.state.mallId };
      const customerPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/search/`, params);
      const customer = (await customerPromise).data;
      var my_customer = customer.find(c => c.line_id === this.props.liff_user_id);
      const couponPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/coupon/line/${this.state.siteId}/list/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      const settingPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/setting/${this.state.siteId}`);
      const mallPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${this.state.siteId}/${this.state.mallId}`);
      const customerDetailPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerdetail/line/${this.state.siteId}`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      const firstBonusPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/firstbonus/line/${this.state.siteId}/${this.state.mallId}`);
      const appLotteryBonusPromise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/line/${this.state.siteId}/${this.state.mallId}`);
      const stamp_master_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/stamp/master/list/line`, { site_id: this.state.siteId, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      const entrytypePromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/entry_type/search/line`, { site_id: this.state.siteId, mall_id: this.state.mallId });
      const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/search/`, { site_id: this.state.siteId, customer_id: my_customer ? my_customer.customer_id : null, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      //設定取得
      const setting = (await settingPromise).data;
      const mall = (await mallPromise).data;
      const firstbonus = (await firstBonusPromise).data;
      const applotterybonus = (await appLotteryBonusPromise).data;
      const stamp_master_data = (await stamp_master_promise).data;
      var entrytype_master = (await entrytypePromise).data;
      const rankCustomer = (await rank_customer_info_promise).data;

      entrytype_master.sort((a, b) => a.plan_id === b.plan_id ? (a.entry_type > b.entry_type ? 1 : -1) : a.plan_id > b.plan_id ? 1 : -1);
      entrytype_master.map((d, idx) => (
        d.m_entry_data.sort((a, b) => a.entry_seq - b.entry_seq)
      ));
      entrytype_master.forEach((data, idx) => (
        data.m_entry_data.forEach(async (entryData, entryDataIdx) => {
          //初期値設定
          if (!this.state.order) {
            this.setState({ order: {} });
          }
          if (data.m_entry_data.length === 1) {
            var newOrder = null;
            if (entryData.entry_data) {
              newOrder = { ...this.state.order, [entryData.param_name]: entryData.entry_data };
            } else {
              newOrder = { ...this.state.order, [entryData.param_name]: entryData.default_value };
            }
            this.setState({ order: newOrder });
          } else {
            const newOrder = { ...this.state.order, [entryData.param_name]: entryData.default_value };
            this.setState({ order: newOrder });
            //this.state.order[entryData.param_name] = entryData.input_type !== "check" ? entryData.default_value : entryData.default_value ? [entryData.default_value] : []
          }
        })
      ));

      const allAppLotteryRanks = [];
      // applotterybonusが配列であることを確認
      if (Array.isArray(applotterybonus)) {
        applotterybonus.forEach(bonus => {
          // 各要素のapp_lottery_ranksが存在するか確認
          if (bonus.app_lottery_ranks && Array.isArray(bonus.app_lottery_ranks)) {
            // app_lottery_ranksをallRanksに追加
            allAppLotteryRanks.push(...bonus.app_lottery_ranks);
          }
        });
      }
      if (my_customer && applotterybonus && allAppLotteryRanks && allAppLotteryRanks.length > 0) {
        const rank_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/line/ranklist/`, { site_id: this.state.siteId, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
        const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/search/`, { site_id: this.state.siteId, customer_id: my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
        //ランクマスタ情報を取得
        const rank_info = (await rank_info_promise).data;
        //自分のランク情報を取得
        const rank_customer_info = (await rank_customer_info_promise).data;
        //自分のランク情報がない場合、最初のランクに設定
        const user_rank = rank_customer_info ? rank_customer_info.rank_id : rank_info[0].rank_id;
        if (allAppLotteryRanks.find(r => r.rank_id === user_rank)) {
          this.setState({ lottery_flag: true });
        }
      } else if (!my_customer && applotterybonus && applotterybonus.length > 0 && allAppLotteryRanks && allAppLotteryRanks > 0) {
        const rank_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/line/ranklist/`, { site_id: this.state.siteId, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
        //ランクマスタ情報を取得
        const rank_info = (await rank_info_promise).data;
        const user_rank = rank_info[0].rank_id;
        if (allAppLotteryRanks.find(r => r.rank_id === user_rank)) {
          this.setState({ lottery_flag: true });
        }
      } else if (!my_customer && applotterybonus && applotterybonus.length > 0) {
        const rank_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/line/ranklist/`, { site_id: this.state.siteId, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
        //ランクマスタ情報を取得
        const rank_info = (await rank_info_promise).data;
        const user_rank = rank_info[0].rank_id;
        if (allAppLotteryRanks.find(r => r.rank_id === user_rank)) {
          this.setState({ lottery_flag: true });
        }
      } else if (applotterybonus.length === 0) {
        this.setState({ lottery_flag: false });
      } else {
        this.setState({ lottery_flag: true });
      }

      //キャンペーン情報取得
      const campaignPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/campaign/line/${this.state.siteId}/list/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId });

      if (!my_customer) {
        // データが無ければ起動時に登録
        var data = {
          'site_id': this.state.siteId,
          'mall_id': this.state.mallId,
          'line_id': this.props.liff_access_token,
          'status': constClass.STATUS.UREG
        };
        // API実行
        try {
          const result = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line`, data)).data;
          if (result.result) {
            my_customer = result.customer;
          } else {
            alert('データの登録に失敗しました。');
          }
        } catch (err) {
          console.log(err);
          alert('エラーが発生しました。');
        }
      }

      const initialQs = this.state.initialQs ? this.state.initialQs : {
        page: this.props.page,
        current_id: this.props.current_id,
        campaign_id: this.props.campaign_id,
        issue_count: this.props.issue_count,
        stamp_uuid: this.props.stamp_uuid,
        benefit_id: this.props.benefit_id,
        event_uuid: this.props.event_uuid,
        checkin_id: this.props.checkin_id,
        stampcard_id: this.props.stampcard_id,
        questionnaire_id: this.props.questionnaire_id,
      };
      // 利用規約に同意してないユーザは必ず利用規約画面に遷移
      if (my_customer && ([constClass.STATUS.UREG].includes(my_customer.status) || !my_customer.t_customer_mall || !my_customer.t_customer_mall.find(c => c.mall_id === Number(this.state.mallId)) || my_customer.t_customer_mall.find(c => c.mall_id === Number(this.state.mallId)).agreement !== constClass.FLAG.ON)) {
        this.props.history.replace(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=`);
      } else if (my_customer && [constClass.STATUS.CCL].includes(my_customer.status)) {
        this.setState({ cancel_modal_flag: true });
        this.props.history.replace(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=stop`);
      } else {
        // 登録済みでトップページ（登録画面）を開いた場合
        if (my_customer && my_customer.status === constClass.STATUS.REG && (this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.USER)) {
          if (initialQs.page === undefined || initialQs.page === null || initialQs.page === '' || initialQs.page === constClass.USER) {
            this.props.history.replace(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${this.getDefaultPage(setting)}`);
          } else {
            var url = `/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${initialQs.page}`;
            if (initialQs.current_id) {
              url += `&current_id=${initialQs.current_id}`;
              this.props.setCurrentCoupon(initialQs.current_id);
            }
            if (initialQs.campaign_id) {
              url += `&campaign_id=${initialQs.campaign_id}`;
              this.props.setCampaignId(initialQs.campaign_id);
            }
            if (initialQs.issue_count) {
              url += `&issue_count=${initialQs.issue_count}`;
              this.props.setIssueCount(initialQs.issue_count);
            }
            if (initialQs.benefit_id) {
              url += `&benefit_id=${initialQs.benefit_id}`;
              this.props.setBenefitId(initialQs.benefit_id);
            }
            if (initialQs.stamp_uuid) {
              url += `&stamp_uuid=${initialQs.stamp_uuid}`;
              this.props.setStampUUID(initialQs.stamp_uuid);
            }
            if (initialQs.event_uuid && initialQs.checkin_id) {
              url += `&event_uuid=${initialQs.event_uuid}&checkin_id=${initialQs.checkin_id}`;
              this.props.setCheckinID(initialQs.checkin_id);
              this.props.setEventUUID(initialQs.event_uuid);
            }
            if (initialQs.event_uuid && !initialQs.checkin_id) {
              url += `&event_uuid=${initialQs.event_uuid}`;
              this.props.setEventUUID(initialQs.event_uuid);
            }
            if (initialQs.stampcard_id && initialQs.questionnaire_id) {
              url += `&stampcard_id=${initialQs.stampcard_id}&questionnaire_id=${initialQs.questionnaire_id}`;
              this.props.setStampCardID(initialQs.stampcard_id);
              this.props.setQuestionnaireID(initialQs.questionnaire_id);
            }
            this.props.history.replace(url);
          }
        }
      }

      const campaignId = (this.props.campaign_id ? this.props.campaign_id : initialQs.campaign_id);
      const campaignlist = (await campaignPromise).data;
      var campaign = campaignlist.find(x => x.campaign_id.toString() === campaignId.toString());
      var my_entry = this.state.my_entry;
      if (campaign && campaign.campaign_id) {
        my_entry = my_customer.t_entry.find(c => c.campaign_id.toString() === campaign.campaign_id.toString());
        if (!my_entry) {
          my_entry = {
            campaign_id: campaign.campaign_id,
            status: constClass.STATUS.UREG,
            privacy_policy: constClass.FLAG.OFF
          }
        }
      }

      const coupon_list = (await couponPromise).data;
      if (my_customer.status === constClass.STATUS.REG && setting[constClass.SETTING.PAYMENT_REQUIRED] === constClass.FLAG.ON) {
        // 決済のチェック 決済未登録・決済登録失敗　または　決済停止中かつ当月の決済無し　の場合は決済が必要
        if (!my_customer.payment_status || [constClass.PAYMENT_STATUS.UPAY, constClass.PAYMENT_STATUS.ERR].includes(my_customer.payment_status) ||
          (my_customer.payment_status === constClass.PAYMENT_STATUS.CCL && new Date(my_customer.last_payment_date).getMonth() < new Date().getMonth())) {
          if (!reload) {
            await this.submitPayment(my_customer);
            this.setState({ pre_modal_flag: true });
          }
        } else {
          my_customer = await this.assignCouponCode(my_customer, coupon_list);
        }
      } else if (my_customer.status === constClass.STATUS.REG) {
        my_customer = await this.assignCouponCode(my_customer, coupon_list);
      }
      const ticketListPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/line/${this.state.siteId}/list/`, { customer_id: my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      const ticketIssueListPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/line/${this.state.siteId}/issuelist/`, { customer_id: my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId });      
      const benefitLotteryTicketListPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${this.state.siteId}/issuelist/`, { customer_id: my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      var eventPromise = null;
      if (this.props.event_uuid) {
        eventPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/event/line/${this.state.siteId}/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId, customer_id: my_customer.customer_id, event_uuid: this.props.event_uuid });
      }
      const ticketGroupPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticketgroup/line/${this.state.siteId}/list/`, { customer_id: my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      const ticketCountPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/line/${this.state.siteId}/countlist/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId });
      const ticketIssueCountPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/line/${this.state.siteId}/issuecountlist/`, { line_id: this.props.liff_access_token, mall_id: this.state.mallId });

      const ticket_list = (await ticketListPromise).data;
      const ticket_issuelist = (await ticketIssueListPromise).data;      
      const benefit_lottery_ticket_list = (await benefitLotteryTicketListPromise).data;
      const event = eventPromise ? (await eventPromise).data : null;

      const ticket_group = (await ticketGroupPromise).data;
      const ticket_count = (await ticketCountPromise).data;
      const ticket_issuecount = (await ticketIssueCountPromise).data;

      const merged_count = [...ticket_count, ...ticket_issuecount].reduce((acc, item) => {
        if (!acc[item.ticket_id]) {
          acc[item.ticket_id] = { ticket_id: item.ticket_id, count: 0 };
        }
        acc[item.ticket_id].count += Number(item.count) || 0;
        return acc;
      }, {});

      const over_ticket = [];
      ticket_group.forEach(group => {
        if (group.m_ticket_group_ticket) {
          const groupTotalCount = group.m_ticket_group_ticket.reduce((sum, t) => {
            const ticketId = t.ticket_id;
            return sum + (merged_count[ticketId]?.count || 0);
          }, 0);

          if (group.max_usage_count !== null && group.max_usage_count !== undefined && groupTotalCount >= group.max_usage_count) {
            group.m_ticket_group_ticket.forEach(t => {
              over_ticket.push(t.ticket_id);
            });
          }
        }
      });

      const filter_ticket_list = this.filterAvailableTicketList(ticket_list, over_ticket);

      const filter_ticket_issuelist = ticket_issuelist.filter(t => !over_ticket.includes(t.ticket_id));

      const customer_detail_type = (await customerDetailPromise).data;
      this.setState({
        my_customer: this.customerToState(my_customer, setting),
        original_customer: my_customer,
        coupon_list,
        ticket_list: filter_ticket_list,
        ticket_issuelist: filter_ticket_issuelist,
        event,
        setting,
        mall,
        campaignlist: campaignlist ? campaignlist : [],
        campaign: campaign,
        my_entry: my_entry,
        initialQs,
        customer_detail_type,
        firstbonus,
        available_point: my_customer.point,
        applotterybonus,
        stamp_master_data,
        entrytype_master,
        benefit_lottery_ticket_list,
        rankCustomer
      });

      this.setReady();
    }
  }

  setReady() {
    if (this.state.my_customer !== null && this.state.coupon_list !== null && this.state.setting !== null && this.meta && this.state.cssLoaded) {
      this.setState({ ready: true });
    } else {
      this.setState({ ready: false });
    }
  }

  customerToState(customer, setting) {
    // 退会済みデータは画面に反映しない
    if (customer.status === constClass.STATUS.CCL) {
      return {
        ...customer,
        customer_name: '',
        customer_kana: '',
        gender: '',
        birth: '',
        phone_number: '',
        postal_code: '',
        address: '',
        card_id: '',
        mail_address: '',
        cancel_cause: '',
        privacy_policy: constClass.FLAG.OFF,
        agreement: constClass.FLAG.OFF,
        t_customer_detail: [],
      }
    } else {
      return {
        ...customer,
        customer_name: customer.customer_name ? customer.customer_name : '',
        customer_kana: customer.customer_kana ? customer.customer_kana : '',
        gender: customer.gender ? customer.gender : '',
        birth: customer.birth ? customer.birth : '',
        phone_number: customer.phone_number ? customer.phone_number : '',
        postal_code: customer.postal_code ? customer.postal_code : '',
        address: customer.address ? customer.address : '',
        card_id: customer.card_id ? customer.card_id.slice(setting['PREFIX_CARD_ID'] ? setting['PREFIX_CARD_ID'].length : 0) : '',
        mail_address: customer.mail_address ? customer.mail_address : '',
        cancel_cause: '',
        privacy_policy: customer.privacy_policy ? customer.privacy_policy : constClass.FLAG.OFF,
        agreement: customer.agreement ? customer.agreement : constClass.FLAG.OFF,
      }
    }
  }

  checkInvalid() {
    const c = this.state.my_customer;
    const inputCheck = (this.state.setting['INPUT_CUSTOMER_NAME'] === constClass.INPUT.REQUIRED && !c.customer_name) ||
      (this.state.setting['INPUT_CUSTOMER_KANA'] === constClass.INPUT.REQUIRED && !c.customer_kana) ||
      (this.state.setting['INPUT_GENDER'] === constClass.INPUT.REQUIRED && !c.gender) ||
      (this.state.setting['INPUT_BIRTH'] === constClass.INPUT.REQUIRED && !c.birth) ||
      (this.state.setting['INPUT_PHONE_NUMBER'] === constClass.INPUT.REQUIRED && !c.phone_number) ||
      (this.state.setting['INPUT_POSTAL_CODE'] === constClass.INPUT.REQUIRED && !c.postal_code) ||
      (this.state.setting['INPUT_ADDRESS'] === constClass.INPUT.REQUIRED && !c.address) ||
      (this.state.setting['INPUT_MAIL_ADDRESS'] === constClass.INPUT.REQUIRED && !c.mail_address) ||
      (this.state.setting['INPUT_CARD_ID'] === constClass.INPUT.REQUIRED && !c.card_id) ||
      ((!!this.state.setting['TERMS_OF_SERVICE_URL'] || !!this.state.setting['PRIVACYPOLICY_URL']) && c.privacy_policy !== constClass.FLAG.OFF) ||
      ((!!this.state.setting['ADDITIONAL_AGREEMENT']) && c.agreement !== constClass.FLAG.ON);
    const inputDetailCheck = this.state.customer_detail_type.filter(c => c.required).reduce((prev, type) => prev || !(Common.getCustomerDetailObject(c.t_customer_detail)[type.entry_type]), false);
    const m = this.state.message;
    const errorCheck = !!m.mail_address || !!m.postal_code || !!m.card_id || !!m.birth || !!m.phone_number;
    return inputCheck || inputDetailCheck || errorCheck;
  }

  getCouponCode(id) {
    return this.state.my_customer.m_coupon_code.find(c => c.coupon_id === id) ? this.state.my_customer.m_coupon_code.find(c => c.coupon_id === id) : {};
  }

  getCurrentTicket() {
    return this.state.ticket_list.find(t => t.ticket_id === this.props.current_id) ? this.state.ticket_list.find(t => t.ticket_id === this.props.current_id) : {};
  }

  async getTicketListIssue() {
    await this.refreshData();
  }

  getCurrentTicketIssue() {
    return this.state.ticket_issuelist.find(t => t.ticket_id === this.props.current_id && t.issue_count === this.props.issue_count) ? this.state.ticket_issuelist.find(t => t.ticket_id === this.props.current_id && t.issue_count === this.props.issue_count) : {};
  }

  // getCurrentBenefitIssue() {
  //   return this.state.benefit_grant_list.find(t => t.benefit_id === this.props.current_id && t.issue_count === this.props.issue_count) ? this.state.benefit_grant_list.find(t => t.benefit_id === this.props.current_id && t.issue_count === this.props.issue_count) : {};
  // }

  getTicketUse(id) {
    return this.state.my_customer.t_ticket_use.find(t => t.ticket_id === id) ? this.state.my_customer.t_ticket_use.find(t => t.ticket_id === id) : {};
  }

  getTicket(id) {
    return this.state.ticket_list.find(t => t.ticket_id === id) ? this.state.ticket_list.find(t => t.ticket_id === id) : {};
  }

  getTicketIssue(count, id) {
    return this.state.ticket_issuelist.find(t => t.ticket_id === id && t.issue_count === count) ? this.state.ticket_issuelist.find(t => t.ticket_id === id && t.issue_count === count) : {};
  }

  getBenefitTicketIssue(count, id) {
    return this.state.benefit_grant_list.find(b => b.benefit_id === id && b.issue_count === count) ? this.state.benefit_grant_list.find(b => b.benefit_id === id && b.issue_count === count) : {};
  }

  resetCustomer() {
    this.setState({
      my_customer: this.customerToState(this.state.original_customer, this.state.setting),
      user_change: false,
      message: {
        mail_address: '',
        gender: '',
        birth: '',
        postal_code: '',
        card_id: '',
      },
    })
  }

  async copyTextToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      // this.setState({ copy_message: 'コピーしました。' });
      // alert('コピーしました。');
      console.log('Async: Copying to clipboard was successful!');
      return true;
    } catch (err) {
      try {
        console.log('Async: Could not copy text: ', err);
        var input = document.createElement('input');
        document.body.appendChild(input);
        input.value = text;
        input.select();
        const result = document.execCommand('copy');
        document.body.removeChild(input);
        if (!result) {
          throw new Error('document.execCommand failed');
        }
        console.log('document.execCommand: Copying to clipboard was successful!');
        return true;
      } catch (err) {
        alert('コピーに失敗しました。お手数ですがクーポンコードを直接入力してください。');
        console.error('document.execCommand: Could not copy text: ', err);
        return false;
      }
    }
  }

  async submit() {
    if (this.checkInvalid() || this.state.disabled) {
      return;
    }
    if (this.props.page === constClass.USERCHANGE) {
      if (this.state.setting['CUSTOMER_CHANGE_CONFIRM'] && !window.confirm(this.state.setting['CUSTOMER_CHANGE_CONFIRM'])) {
        return;
      }
    } else {
      if (this.state.setting['CUSTOMER_REG_CONFIRM'] && !window.confirm(this.state.setting['CUSTOMER_REG_CONFIRM'])) {
        return;
      }
    }
    this.setState({ disabled: true });
    var message = this.state.message;
    // customerデータ準備
    var data = {
      'site_id': this.state.siteId,
      'mall_id': this.state.mallId,
      'line_id': this.props.liff_access_token,
      'customer_name': this.state.my_customer.customer_name,
      'customer_kana': this.state.my_customer.customer_kana,
      'gender': this.state.my_customer.gender,
      'birth': this.state.my_customer.birth,
      'phone_number': this.state.my_customer.phone_number,
      'postal_code': this.state.my_customer.postal_code,
      'address': this.state.my_customer.address,
      'card_id': this.state.my_customer.card_id ? this.state.setting['PREFIX_CARD_ID'] + this.state.my_customer.card_id : '',
      'mail_address': this.state.my_customer.mail_address,
      'privacy_policy': this.state.my_customer.privacy_policy,
      'agreement': this.state.my_customer.agreement,
      'status': constClass.STATUS.REG,
      'register_date': this.props.page === constClass.REGISTRATIONUSER ? this.state.my_customer.register_date : new Date(),
      't_customer_detail': this.state.my_customer.t_customer_detail,
    };
    // 退会→登録のとき決済失敗のログを削除する(決済ステータスを決済停止中にする)
    if (this.state.my_customer.status === constClass.STATUS.CCL && this.state.my_customer.payment_status === constClass.PAYMENT_STATUS.ERR) {
      data.payment_status = constClass.PAYMENT_STATUS.CCL;
    }
    // API実行
    try {
      if (this.props.page === constClass.REGISTRATIONUSER) {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/${this.state.my_customer.customer_id}/updatechange`, data);
      } else if (this.props.page === constClass.USER) {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/${this.state.my_customer.customer_id}`, data);
      }
      if (this.props.page === constClass.REGISTRATIONUSER) {
        alert('変更が完了しました。');
        await this.refreshData();
        // this.setState({ pre_modal_flag: false });
        this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.USERCHANGE}`);
      } else {
        // alert('登録が完了しました。');
        await this.refreshData();
        // this.props.history.replace(`/${this.state.siteId}/?page=${constClass.COUPONLIST}`);
      }
      this.setState({
        disabled: false,
        message: {
          mail_address: '',
          gender: '',
          birth: '',
          postal_code: '',
          card_id: '',
          phone_number: '',
        },
        user_change: false,
      });
    } catch (err) {
      console.log(util.inspect(err));
      if (err.response && err.response.data) {
        alert(err.response.data);
      } else {
        alert('エラーが発生しました。');
      }
      this.setState({ disabled: false, message });
    }
  }

  async submitTerms() {
    if (this.state.disabled) {
      return;
    }
    var shop;
    if (this.state.shopCode) {
      var params = {
        'site_id': this.state.siteId,
        'mall_id': this.state.mallId,
        'line_id': this.props.liff_access_token,
        'shop_code': this.state.shopCode,
      };
      shop = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/line/shopcodefind`, params)).data;
    }
    var data = {
      'site_id': this.state.siteId,
      'customer_id': this.state.my_customer.customer_id,
      'mall_id': this.state.mallId,
      'register_date': new Date(),
      'agreement': constClass.FLAG.ON,
      'shop_id': shop ? shop.shop_id : null,
      'line_id': this.props.liff_access_token,
    };
    // API実行
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customermall/line`, data);
      await this.refreshData();
      if ([constClass.STATUS.UREG].includes(this.state.my_customer.status)) {
        this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.USER}`);
      }
    } catch (err) {
      // alert('エラーが発生しました。');
      console.log(err);
    }
  }

  /* チケット使用 */
  async submitBenefitTicket(issue_count, benefit_id) {
    if (this.state.disabled) {
      return;
    }
    if (!this.getBenefitTicketIssue(issue_count, benefit_id).use_date) {
      if (!window.confirm('クーポンの使用にはスタッフの確認が必要です。使用してもよろしいですか？')) {
        return;
      }
      // 検索条件
      const params = {
        customer_id: this.state.my_customer.customer_id,
        issue_count: issue_count,
        line_id: this.props.liff_access_token,
        mall_id: this.state.mallId
      };
      // API実行
      try {
        const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/line/customer/${this.state.siteId}/${benefit_id}/use`, params);
        if (!result.msg) {
          window.alert('クーポンを使用しました。');
        } else if (result.msg) {
          window.alert(result.msg);
        }
      } catch (err) {
        // alert('エラーが発生しました。');
        console.log(err);
      } finally {
        this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.MEMBERSHIPPASS}`);
        await this.refreshData();
      }
    }
  }

  /* チケット使用 */
  async submitTicket(issue_count, ticket_id) {
    if (this.state.disabled) {
      return;
    }
    if (!this.getTicketIssue(issue_count, ticket_id).use_date) {
      if (!window.confirm('クーポンの使用にはスタッフの確認が必要です。使用してもよろしいですか？')) {
        return;
      }
      // 検索条件
      const params = {
        customer_id: this.state.my_customer.customer_id,
        issue_count: issue_count,
        line_id: this.props.liff_access_token,
        mall_id: this.state.mallId
      };
      // API実行
      try {
        const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/line/customer/${this.state.siteId}/${ticket_id}/use`, params);
        if (!result.data.msg) {
          window.alert('クーポンを使用しました。');
        } else if (result.data.msg) {         
          window.alert(result.data.msg);
        }
      } catch (err) {
        // alert('エラーが発生しました。');
        console.log(err);
      } finally {
        this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.MEMBERSHIPPASS}`);
        await this.refreshData();
      }
    }
  }

  async refreshAvailablePoints() {
    try {
      const customer_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/search/`, { site_id: this.state.siteId, mall_id: this.state.mallId, line_id: this.props.liff_access_token })).data;
      const customer = customer_data.find(c => c.line_id === this.props.liff_user_id);
      console.log(customer);
      this.ticketBack();
      this.setState({ available_point: customer.point ? customer.point : 0 });
    } catch (err) {
      console.error(err);
    }
  }

  renderHeader() {
    const titlename = () => {
      switch (this.props.page) {
        case constClass.USER: return `お客様情報`;
        case constClass.USERCHANGE: return `お客様情報`;
        case constClass.REGISTRATIONUSER: return `お客様情報変更`;
        case constClass.FREETICKETLIST: return `クーポン一覧`;
        case constClass.PAIDTICKETLIST: return `ポイントを使う`;
        case constClass.FREETICKETUSE: return `クーポン`;
        case constClass.FREETICKETISSUEUSE: return `クーポン`;
        case constClass.PAIDTICKETUSE: return `クーポン`;
        case constClass.PAIDTICKETISSUEUSE: return `クーポン`;
        case constClass.ENTRY: return `ポイント一覧`;
        case constClass.POINTLIST: return `ポイント一覧`;
        case constClass.MEMBERSHIPPASS: return `会員証`;
        case constClass.POINTHISTORY: return `ポイント履歴`;
        case constClass.FIRSTBONUS: return `初回登録特典`;
        case constClass.HELP: return `ヘルプ`;
        default: return `利用規約`;
      }
    }
    return (
      <header className="header" ref={this.headerRef}>
        <div className="row mx-0">
          <div className={`col section text-center`}>
            {/* <img src="logo.png" alt="logo" /> */}
            <span>{titlename(this)}</span>
          </div>
        </div>
        <div className="row mx-0 wave mb-2"></div>
      </header>
    );
  }

  renderTerms(confirmation) {
    return (
      <div className="terms-body">
        {(!confirmation && this.state.firstbonus && this.state.firstbonus.banner_image_url) &&
          <div className='col-12 bg-white px-0 mb-1 text-center'>
            <img className="w-100" src={`/${this.state.siteId}/${this.state.firstbonus.banner_image_url}`} alt="初回特典" />
          </div>
        }
        {((this.props.page === null || this.props.page === undefined || this.props.page === '' || this.props.page === constClass.TERMS) && this.state.mall['terms_title']) &&
          <div className="terms_title">
            <div className="customer-text mb-4 text-left">
              <div className="col py-0 px-0 align-self-center text-black" dangerouslySetInnerHTML={{ __html: this.state.mall.terms_title }} />
            </div>
          </div>
        }
        <div className="terms">
          <div className="customer-input">
            <div className="col py-0 px-0 align-self-center" dangerouslySetInnerHTML={{ __html: this.state.mall.terms }} />
          </div>
        </div>
        {!confirmation &&
          <React.Fragment>
            <div className="row mx-0 pt-3 pb-3">
              <div className="col-12 text-center p-0">
                <button
                  disabled={this.state.disabled}
                  className="button text-black bg-lightwhite mt-3"
                  onClick={() => { this.scrollPageTop(); this.submitTerms(); }}>
                  同意する
                </button>
              </div>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }

  renderHelp() {
    return (
      <React.Fragment>
        <div className="col-12 text-center pt-3 pb-3">
          <img src={`/${this.state.siteId}/howtouse.jpg`} alt='how to use' className='w-100' />
        </div>
      </React.Fragment>
    );
  }

  renderUser(change) {
    const renderInput = (setting, name, type, suffix) => {
      const large_name = String(name).toUpperCase();
      const entry_type = {
        entry_type: name,
        required: setting['INPUT_' + large_name] === constClass.INPUT.REQUIRED ? 1 : 0,
        entry_type_name: setting['LABEL_' + large_name],
        detail_data: [],
        notice: setting['NOTICE_' + large_name],
        info: setting['INFO_' + large_name],
      }
      if (name === 'gender') {
        entry_type.detail_data = [
          { input_type: 'radio', entry_type: name, entry_seq: 1, entry_name: constClass.GENDER_NAME.MAN, entry_data: constClass.GENDER.MAN, param_name: name },
          { input_type: 'radio', entry_type: name, entry_seq: 2, entry_name: constClass.GENDER_NAME.WOMAN, entry_data: constClass.GENDER.WOMAN, param_name: name },
          { input_type: 'radio', entry_type: name, entry_seq: 3, entry_name: constClass.GENDER_NAME.OTHER, entry_data: constClass.GENDER.OTHER, param_name: name },
        ]
      } else if (name === 'birth') {
        entry_type.detail_data = [
          { input_type: type, entry_type: name, entry_seq: 1, param_name: name, range_to: '1900', use_year: setting['INPUT_BIRTH_YEAR'], use_month: setting['INPUT_BIRTH_MONTH'], use_date: setting['INPUT_BIRTH_DATE'] },
        ]
      } else {
        entry_type.detail_data = [
          { input_type: type, entry_type: name, entry_seq: 1, param_name: name, placeholder: setting['PLACEHOLDER_' + large_name], prefix: setting['PREFIX_' + large_name], max_length: name === 'postal_code' ? 7 : name === 'phone_number' ? 14 : name === 'card_id' ? 15 : null },
        ]
      }
      return [constClass.INPUT.ENABLED, constClass.INPUT.REQUIRED].includes(setting['INPUT_' + large_name]) ? renderInputDetail(entry_type, this.state.my_customer, this.changeCustomer, suffix) : null;
    }

    const renderInputDetail = (entry_type, values, changeHandler, suffix) => {
      const setYears = (from, to) => {
        const items = [];
        const nowYear = new Date().getFullYear();
        var range_from = from ? from : nowYear;
        var range_to = to ? to : nowYear;
        items.push(<option value="" key={"-"}>- 年 -</option>);
        if (range_from < range_to) {
          for (let i = range_from; i <= range_to; i++) {
            items.push(<option value={i} key={i}>{i}年</option>);
          }
        } else {
          for (let i = range_from; i >= range_to; i--) {
            items.push(<option value={i} key={i}>{i}年</option>);
          }
        }
        return items;
      }
      const setMonth = (year) => {
        const items = [];
        const now = new Date();
        const nowYear = now.getFullYear();
        const nowMonth = now.getMonth() + 1;
        items.push(<option value="" key={"-"}>- 月 -</option>);
        for (let i = 1; i <= 12; i++) {
          if (year < nowYear || (Number(year) === nowYear && i <= nowMonth)) {
            items.push(<option value={("00" + i).slice(-2)} key={i}>{i}月</option>);
          }
        }
        return items;
      }
      const setDay = (value) => {
        const items = [];
        const year = value.slice(0, 4);
        const month = value.slice(4, 6);
        const now = new Date();
        items.push(<option value="" key={"-"}>- 日 -</option>)
        for (let i = 1; i <= 31; i++) {
          const date = new Date(year + '/' + month + '/' + ("00" + i).slice(-2));
          if (!year || !Number(month) || (date.getDate() === i && date <= now)) {
            items.push(<option value={("00" + i).slice(-2)} key={i}>{i}日</option>)
          }
        }
        return items;
      }
      const handleDateChange = (e, changeEvent) => {
        const target = e.target;
        const type = target.id.split('-')[0];
        const seq = target.id.split('-')[1];
        var temp = Number(document.getElementById(type + '-' + seq + '-y') ? document.getElementById(type + '-' + seq + '-y').value : 0) * 10000;
        temp += Number(document.getElementById(type + '-' + seq + '-m') ? document.getElementById(type + '-' + seq + '-m').value : 0) * 100;
        temp += Number(document.getElementById(type + '-' + seq + '-d') ? document.getElementById(type + '-' + seq + '-d').value : 0);
        changeEvent({
          target: {
            type: 'text',
            name: target.name,
            value: ("00000000" + temp).slice(-8)
          }
        })
      }
      return <React.Fragment key={entry_type.entry_type}>
        <div className="input-label row mx-0">
          <span className='entry_name'>{entry_type.entry_type_name}</span>
        </div>
        {change && entry_type.entry_type === 'birth' && (
          <span className='ml-4'>※登録後の変更はできません</span>
        )}
        {change &&
          <div className="form-group">
            <div className="input-control row mx-0 text-left">
              {entry_type.detail_data.map(d =>
                <React.Fragment key={d.entry_type + '-' + d.entry_seq}>
                  {['text', 'number'].includes(d.input_type) && <React.Fragment>
                    {d.prefix && <div className={`col-auto px-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-prefix'}`}><span>{d.prefix}</span></div>}
                    <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`}><input type={d.input_type} className="form-control selectbox" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} value={values[d.entry_type]} onChange={changeHandler} placeholder={d.placeholder} maxLength={d.max_length}></input></div>
                    {suffix && <div className={`col-auto px-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-suffix'}`}><span>{suffix}</span></div>}
                  </React.Fragment>}
                  {d.input_type === 'radio' && <React.Fragment>
                    <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                      <div className="row px-0 mx-0">
                        <div className="col-3 px-0 mx-0 align-self-center">
                          <input type="radio" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} onChange={changeHandler} value={d.entry_data} checked={values[d.entry_type] === d.entry_data} />
                        </div>
                        <div className="col-9 px-1 mx-0 align-self-center">
                          <label className="my-0 fontweight" htmlFor={d.entry_type + '-' + d.entry_seq}>{d.entry_name}</label>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>}
                  {d.input_type === 'date' && <React.Fragment>
                    <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                      <div className="row px-0 mx-0">
                        {d.use_year === constClass.FLAG.ON && <div className={`col-4 px-0 mx-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-y'}`}>
                          <select className="form-control text-center selectbox" id={d.entry_type + '-' + d.entry_seq + '-y'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(0, 4)}>
                            {setYears(d.range_from, d.range_to)}
                          </select>
                        </div>}
                        {d.use_month === constClass.FLAG.ON && <div className={`col-4 px-1 mx-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-m'}`}>
                          <select className="form-control text-center selectbox" id={d.entry_type + '-' + d.entry_seq + '-m'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(4, 6)}>
                            {setMonth(values[d.entry_type].slice(0, 4))}
                          </select>
                        </div>}
                        {d.use_date === constClass.FLAG.ON && <div className={`col-4 px-1 mx-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-d'}`}>
                          <select className="form-control text-center selectbox" id={d.entry_type + '-' + d.entry_seq + '-d'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(6, 8)}>
                            {setDay(values[d.entry_type])}
                          </select>
                        </div>}
                      </div>
                    </div>
                  </React.Fragment>}
                </React.Fragment>
              )}
            </div>
            {entry_type.notice &&
              <div className="input-notice row mx-0 px-3-env text-left">
                <div className="col px-0 font-weight-normal">{Common.getBrString(entry_type.notice)}</div>
              </div>
            }
            {this.state.message[entry_type.entry_type] &&
              <div className="input-message row mx-0 px-3-env text-left">
                <div className="col px-0 text-danger font-weight-normal">{Common.getBrString(this.state.message[entry_type.entry_type])}</div>
              </div>
            }
            {entry_type.info &&
              <div className="input-info row mx-0 px-3-env text-left text-info mt-3">
                <div className="col px-0 font-weight-normal">{Common.getBrString(entry_type.info)}</div>
              </div>
            }
          </div>
        }
        {!change &&
          <div className="input-disp row text-left form-group customer-detail-text">
            {['text', 'number'].includes(entry_type.detail_data.find(() => true).input_type) && <div className="col px-3 py-1 align-self-center border">
              {values[entry_type.entry_type] ? (entry_type.detail_data.find(() => true).prefix ? entry_type.detail_data.find(() => true).prefix + values[entry_type.entry_type] : values[entry_type.entry_type]) : '未登録'}
            </div>}
            {['radio'].includes(entry_type.detail_data.find(() => true).input_type) && <div className="col px-3 py-1 align-self-center border">
              {values[entry_type.entry_type] ? entry_type.detail_data.find(p => p.entry_data === values[entry_type.entry_type]).entry_name : '未登録'}
            </div>}
            {['date'].includes(entry_type.detail_data.find(() => true).input_type) && <div className="col px-3 py-1 align-self-center border">
              {values[entry_type.entry_type] ? Common.getDateObject(values[entry_type.entry_type]).str : '未登録'}
            </div>}
          </div>
        }
      </React.Fragment>
    }
    return (
      <div id="user" className="customer-header">
        <div className="customer-text mb-3">
          お客様情報
        </div>
        <div className="bg-white">
          <div>
            {((this.props.page === null || this.props.page === undefined || this.props.page === '') && this.state.setting['CUSTOMER_REG_HEADER']) &&
              <div className="col py-0 px-0 align-self-center">
                {Common.getBrString(this.state.setting['CUSTOMER_REG_HEADER'])}
              </div>

            }
            {(this.props.page === constClass.USER && this.state.setting['CUSTOMER_DISP_HEADER']) &&

              <div className="col py-0 px-0 align-self-center">
                {Common.getBrString(this.state.setting['CUSTOMER_DISP_HEADER'])}
              </div>

            }
            {(this.props.page === constClass.USERCHANGE && this.state.setting['CUSTOMER_CHANGE_HEADER']) &&
              <div className="customer-header row mx-0 pt-2 pb-1 text-center">
                <div className="col py-0 px-0 align-self-center">
                  {Common.getBrString(this.state.setting['CUSTOMER_CHANGE_HEADER'])}
                </div>
              </div>
            }
            <div className="customer row mx-0 pt-2">
              <div className="col py-0 px-0 align-self-center">
                {renderInput(this.state.setting, 'customer_name', 'text')}
                {renderInput(this.state.setting, 'customer_kana', 'text')}
                {renderInput(this.state.setting, 'gender', 'radio')}
                {renderInput(this.state.setting, 'birth', 'date')}
                {renderInput(this.state.setting, 'phone_number', 'text')}
                {/* <div className='px-1'><button className="btn btn-enable" onClick={() => this.searchPostalCode()}>住所から検索</button></div> */}
                {renderInput(this.state.setting, 'postal_code', 'text')}
                {renderInput(this.state.setting, 'address', 'text')}
                {renderInput(this.state.setting, 'mail_address', 'text')}
                {renderInput(this.state.setting, 'card_id', 'text')}
                {this.state.customer_detail_type.map(t => renderInputDetail(t, Common.getCustomerDetailObject(this.state.my_customer.t_customer_detail), this.changeCustomerDetail))}

              </div>
            </div>
            {Common.getFunctionEnabled(this.state.setting, 'NIMOCLE_ID_LINKAGE') && this.state.my_customer.status === constClass.STATUS.REG && (
              <div className="row mx-0">
                <div className="col py-0 px-0 align-self-center">
                  <div className="row mx-0 mb-1" style={{ border: '1px solid #ffffff', borderRadius: '14px', padding: '16px', background: '#ffffff' }}>
                    <div className="col px-0">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7C858D" strokeWidth="1.8"><rect x="2.5" y="5.5" width="19" height="13" rx="2" /><path d="M2.5 9.5h19" /></svg>
                          <span className="text-black" style={{ fontSize: '0.8125rem', fontWeight: 'bold' }}>nimocle ID × LINE連携</span>
                        </div>
                        <span
                          style={{
                            display: 'inline-block',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            padding: '0.2rem 0.7rem',
                            borderRadius: '999px',
                            whiteSpace: 'nowrap',
                            backgroundColor: this.state.my_customer.nimocle_linkage_status === constClass.NIMOCLE_LINKAGE_STATUS.REG ? '#178a30' : '#fdf1e0',
                            color: this.state.my_customer.nimocle_linkage_status === constClass.NIMOCLE_LINKAGE_STATUS.REG ? '#ffffff' : '#8a5a10',
                          }}
                        >
                          {this.state.my_customer.nimocle_linkage_status === constClass.NIMOCLE_LINKAGE_STATUS.REG ? '連携済み' : '未連携'}
                        </span>
                      </div>
                      {this.state.my_customer.nimocle_linkage_status === constClass.NIMOCLE_LINKAGE_STATUS.REG ? (
                        <a href={this.state.setting['NIMOCLE_LIFF_URL'] || '#'} className="text-black d-flex align-items-center" style={{ fontSize: '0.8125rem', fontWeight: 'bold', textDecoration: 'none', gap: '4px' }}>
                          登録内容を確認する
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#7C858D" strokeWidth="3" strokeLinecap="round"><path d="M9 6l6 6-6 6" /></svg>
                        </a>
                      ) : (
                        <button
                          className="button text-black bg-lightwhite w-100"
                          onClick={() => { window.location.href = this.state.setting['NIMOCLE_LIFF_URL'] || '#'; }}
                        >
                          ID連携をする
                        </button>
                      )}
                      {(this.state.my_customer.nimocle_linkage_status !== constClass.NIMOCLE_LINKAGE_STATUS.REG) &&
                        <div className="text-left mt-2" style={{ fontSize: '0.75rem', color: '#5e5f5e' }}>
                          nimocleカードと連携すると、<br />お買い物に応じてポイントが貯まります。
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
            {change &&
              <React.Fragment>
                {(this.state.setting['ADDITIONAL_AGREEMENT']) &&
                  <React.Fragment>
                    <div className="customer-agreement additional-agreement row mx-0 px-3-env py-0 mt-1 mb-1">
                      <div className="col-2">
                        <input type="checkbox" className="form-control" id="agreement" name="agreement" value="true" checked={this.state.my_customer.agreement === constClass.FLAG.ON} onChange={this.changeCustomer}></input>
                      </div>
                      <div className="col-10">
                        <label className="mb-0" htmlFor="agreement">
                          {Common.getBrString(this.state.setting['ADDITIONAL_AGREEMENT'])}
                        </label>
                      </div>
                    </div>
                  </React.Fragment>
                }
                {this.state.setting['ADDITIONAL_AGREEMENT_CONTENT'] &&
                  <div className="additional-agreement-content row mx-0 px-3-env py-0 mt-1 mb-1">
                    <div className="col" dangerouslySetInnerHTML={{ __html: this.state.setting['ADDITIONAL_AGREEMENT_CONTENT'] }}>
                    </div>
                  </div>
                }
              </React.Fragment>
            }
            {!change &&
              <div>
                <div className="customer-link row mx-0 px-3-env pt-2 pb-1">
                  <div className="col text-center">
                    <div className='link-blue'
                      onClick={() => { this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.TERMS}`); this.scrollPageTop(); }}>
                      <u>利用規約</u>
                    </div>
                  </div>
                </div>
                {this.state.setting['PRIVACYPOLICY_URL'] &&
                  <div className="customer-link row mx-0 px-3-env pt-1 pb-1">
                    <div className="col text-center">
                      <a href={this.state.setting['PRIVACYPOLICY_URL']} target="_blank" rel="noreferrer"><u>プライバシーポリシー</u></a>
                    </div>
                  </div>
                }
              </div>
            }
            {this.state.setting['LP_URL'] &&
              <div className="customer-link row mx-0 px-3-env pt-1 pb-2">
                <div className="col text-center">
                  <a href={Common.getExternalUrl(this.state.setting['LP_URL'])} target="_blank" rel="noreferrer"><u>{this.site_name}について</u></a>
                </div>
              </div>
            }
            {change &&
              <div className="customer-submit pt-2 pb-3">
                <div className="row mx-0">
                  <div className="col-12 text-center p-0">
                    <button
                      disabled={this.checkInvalid() || this.state.disabled}
                      className="button text-black bg-lightwhite"
                      onClick={() => { this.submit() }}>
                      {this.props.page === constClass.USERCHANGE ? this.state.setting['CUSTOMER_CHANGE_BUTTON'] : this.state.setting['CUSTOMER_REG_BUTTON']}
                    </button>
                  </div>
                  {(this.props.page !== constClass.USERCHANGE && this.state.setting['CUSTOMER_REG_BANNER']) &&
                    <div className="col-12 text-center px-0 pt-2">
                      <img src={`/${this.state.siteId}/${this.state.setting['CUSTOMER_REG_BANNER']}`} className="w-100" alt={"バナー"} />
                    </div>
                  }
                </div>
                {(this.props.page !== constClass.USERCHANGE && this.state.setting['CUSTOMER_REG_BUTTON_NOTICE']) &&
                  <div className="customer-submit-notice row mx-0 px-3-env">
                    <div className="col-12 text-center p-0">
                      <span>{this.state.setting['CUSTOMER_REG_BUTTON_NOTICE']}</span>
                    </div>
                  </div>
                }
                {(this.props.page === constClass.USERCHANGE && this.state.setting['CUSTOMER_CHANGE_BUTTON_NOTICE']) &&
                  <div className="customer-submit-notice row mx-0 px-3-env">
                    <div className="col-12 text-center p-0">
                      <span>{this.state.setting['CUSTOMER_CHANGE_BUTTON_NOTICE']}</span>
                    </div>
                  </div>
                }
                {this.props.page === constClass.USERCHANGE &&
                  <div className="customer-back row mx-0 px-3-env pt-2 pb-3">
                    <div className="col-12 text-center p-0">
                      <button
                        disabled={this.state.disabled}
                        className="btn btn-enable w-100 py-2"
                        onClick={() => { this.resetCustomer(); this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.USER}`); this.scrollPageTop(); }}>
                        保存せずに戻る
                      </button>
                    </div>
                  </div>
                }
                {this.props.page === constClass.USER &&
                  <div className="customer-link">
                    <div className="col text-center my-4">
                      <div className='return-saving'
                        disabled={this.state.disabled}
                        onClick={() => { this.resetCustomer(); this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=`); this.scrollPageTop(); }}>
                        保存せずに戻る
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            {!change &&
              <React.Fragment>
                <div className="customer-submit pb-3">
                  <div className="col-12 text-center" style={{ padding: '0 16px' }}>
                    <button
                      disabled={this.state.disabled}
                      className="button text-black bg-lightwhite w-100"
                      onClick={() => { this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.REGISTRATIONUSER}`); this.scrollPageTop(); }}>
                      お客様情報変更
                    </button>
                  </div>
                </div>
                <div className="col-12 text-center pt-3 pb-3">
                  <img src={`/${this.state.siteId}/howtouse.jpg`} alt='how to use' className='w-100' />
                </div>
              </React.Fragment>
            }
          </div>
        </div>
      </div>
    );
  }

  renderRegistrationUser() {
    const renderInput = (setting, name, type, suffix) => {
      const large_name = String(name).toUpperCase();
      const entry_type = {
        entry_type: name,
        required: setting['INPUT_' + large_name] === constClass.INPUT.REQUIRED ? 1 : 0,
        entry_type_name: setting['LABEL_' + large_name],
        detail_data: [],
        notice: setting['NOTICE_' + large_name],
        info: setting['INFO_' + large_name],
      }
      if (name === 'gender') {
        entry_type.detail_data = [
          { input_type: 'radio', entry_type: name, entry_seq: 1, entry_name: constClass.GENDER_NAME.MAN, entry_data: constClass.GENDER.MAN, param_name: name },
          { input_type: 'radio', entry_type: name, entry_seq: 2, entry_name: constClass.GENDER_NAME.WOMAN, entry_data: constClass.GENDER.WOMAN, param_name: name },
          { input_type: 'radio', entry_type: name, entry_seq: 3, entry_name: constClass.GENDER_NAME.OTHER, entry_data: constClass.GENDER.OTHER, param_name: name },
        ]
      } else if (name === 'birth') {
        entry_type.detail_data = [
          { input_type: type, entry_type: name, entry_seq: 1, param_name: name, range_to: '1900', use_year: setting['INPUT_BIRTH_YEAR'], use_month: setting['INPUT_BIRTH_MONTH'], use_date: setting['INPUT_BIRTH_DATE'] },
        ]
      } else {
        entry_type.detail_data = [
          { input_type: type, entry_type: name, entry_seq: 1, param_name: name, placeholder: setting['PLACEHOLDER_' + large_name], prefix: setting['PREFIX_' + large_name], max_length: name === 'postal_code' ? 7 : name === 'phone_number' ? 14 : name === 'card_id' ? 15 : null },
        ]
      }
      return [constClass.INPUT.ENABLED, constClass.INPUT.REQUIRED].includes(setting['INPUT_' + large_name]) ? renderInputDetail(entry_type, this.state.my_customer, this.changeCustomer, suffix) : null;
    }

    const renderInputDetail = (entry_type, values, changeHandler, suffix) => {
      const setYears = (from, to) => {
        const items = [];
        const nowYear = new Date().getFullYear();
        var range_from = from ? from : nowYear;
        var range_to = to ? to : nowYear;
        items.push(<option value="" key={"-"}>- 年 -</option>);
        if (range_from < range_to) {
          for (let i = range_from; i <= range_to; i++) {
            items.push(<option value={i} key={i}>{i}年</option>);
          }
        } else {
          for (let i = range_from; i >= range_to; i--) {
            items.push(<option value={i} key={i}>{i}年</option>);
          }
        }
        return items;
      }
      const setMonth = (year) => {
        const items = [];
        const now = new Date();
        const nowYear = now.getFullYear();
        const nowMonth = now.getMonth() + 1;
        items.push(<option value="" key={"-"}>- 月 -</option>);
        for (let i = 1; i <= 12; i++) {
          if (year < nowYear || (Number(year) === nowYear && i <= nowMonth)) {
            items.push(<option value={("00" + i).slice(-2)} key={i}>{i}月</option>);
          }
        }
        return items;
      }
      const setDay = (value) => {
        const items = [];
        const year = value.slice(0, 4);
        const month = value.slice(4, 6);
        const now = new Date();
        items.push(<option value="" key={"-"}>- 日 -</option>)
        for (let i = 1; i <= 31; i++) {
          const date = new Date(year + '/' + month + '/' + ("00" + i).slice(-2));
          if (!year || !Number(month) || (date.getDate() === i && date <= now)) {
            items.push(<option value={("00" + i).slice(-2)} key={i}>{i}日</option>)
          }
        }
        return items;
      }
      const handleDateChange = (e, changeEvent) => {
        const target = e.target;
        const type = target.id.split('-')[0];
        const seq = target.id.split('-')[1];
        var temp = Number(document.getElementById(type + '-' + seq + '-y') ? document.getElementById(type + '-' + seq + '-y').value : 0) * 10000;
        temp += Number(document.getElementById(type + '-' + seq + '-m') ? document.getElementById(type + '-' + seq + '-m').value : 0) * 100;
        temp += Number(document.getElementById(type + '-' + seq + '-d') ? document.getElementById(type + '-' + seq + '-d').value : 0);
        changeEvent({
          target: {
            type: 'text',
            name: target.name,
            value: ("00000000" + temp).slice(-8)
          }
        })
      }
      return <React.Fragment key={entry_type.entry_type}>
        <div className="input-label row mx-0">
          <span className='entry_name'>{entry_type.entry_type_name}</span>
        </div>
        <span className={`text-${entry_type.required === 1 ? 'required' : 'optional'}`}>{entry_type.required === 1 ? '必須' : '任意'}</span>
        <div className="input-body form-group">
          <div className="input-control row mx-0 px-3-env text-left">
            {entry_type.detail_data.map(d =>
              <React.Fragment key={d.entry_type + '-' + d.entry_seq}>
                {['text', 'number'].includes(d.input_type) && <React.Fragment>
                  {d.prefix && <div className={`col-auto px-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-prefix'}`}><span>{d.prefix}</span></div>}
                  <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`}><input type={d.input_type} className="form-control selectbox" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} value={values[d.entry_type]} onChange={changeHandler} placeholder={d.placeholder} maxLength={d.max_length}></input></div>
                  {suffix && <div className={`col-auto px-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-suffix'}`}><span>{suffix}</span></div>}
                </React.Fragment>}
                {d.input_type === 'radio' && <React.Fragment>
                  <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                    <div className="row px-0 mx-0">
                      <div className="col-3 px-0 mx-0 align-self-center">
                        <input type="radio" className="form-control" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} onChange={changeHandler} value={d.entry_data} checked={values[d.entry_type] === d.entry_data} />
                      </div>
                      <div className="col-9 px-1 mx-0 align-self-center">
                        <label className="my-0" htmlFor={d.entry_type + '-' + d.entry_seq}>{d.entry_name}</label>
                      </div>
                    </div>
                  </div>
                </React.Fragment>}
                {d.input_type === 'date' && <React.Fragment>
                  <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                    <div className="row px-0 mx-0">
                      {d.use_year === constClass.FLAG.ON && <div className={`col-4 px-0 mx-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-y'}`}>
                        <select className="form-control text-center selectbox" id={d.entry_type + '-' + d.entry_seq + '-y'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(0, 4)} disabled>
                          {setYears(d.range_from, d.range_to)}
                        </select>
                      </div>}
                      {d.use_month === constClass.FLAG.ON && <div className={`col-4 px-1 mx-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-m'}`}>
                        <select className="form-control text-center selectbox" id={d.entry_type + '-' + d.entry_seq + '-m'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(4, 6)} disabled>
                          {setMonth(values[d.entry_type].slice(0, 4))}
                        </select>
                      </div>}
                      {d.use_date === constClass.FLAG.ON && <div className={`col-4 px-1 mx-0 align-self-center ${d.entry_type + '-' + d.entry_seq + '-d'}`}>
                        <select className="form-control text-center selectbox" id={d.entry_type + '-' + d.entry_seq + '-d'} name={d.entry_type} onChange={(e) => handleDateChange(e, changeHandler)} value={values[d.entry_type].slice(6, 8)} disabled>
                          {setDay(values[d.entry_type])}
                        </select>
                      </div>}
                    </div>
                  </div>
                </React.Fragment>}
                {d.input_type === 'checkbox' && <React.Fragment>
                  <div className={`col px-0 align-self-center ${d.entry_type + '-' + d.entry_seq}`} key={d.entry_type + '-' + d.entry_seq}>
                    <div className="row px-0 mx-0">
                      <div className="col-2">
                        <input type="checkbox" className="form-control" id={d.entry_type + '-' + d.entry_seq} name={d.entry_type} value="true" checked={values[d.entry_type] === constClass.FLAG.ON} onChange={changeHandler}></input>
                      </div>
                      <div className="col-10">
                        <label className="my-0" htmlFor={d.entry_type + '-' + d.entry_seq}>{d.entry_name}</label>
                      </div>
                    </div>
                  </div>
                </React.Fragment>}
              </React.Fragment>
            )}
          </div>
          {entry_type.notice &&
            <div className="input-notice row mx-0 px-3-env text-left">
              <div className="col px-0 font-weight-normal">{Common.getBrString(entry_type.notice)}</div>
            </div>
          }
          {this.state.message[entry_type.entry_type] &&
            <div className="input-message row mx-0 px-3-env text-left">
              <div className="col px-0 text-danger font-weight-normal">{Common.getBrString(this.state.message[entry_type.entry_type])}</div>
            </div>
          }
          {entry_type.info &&
            <div className="input-info row mx-0 px-3-env text-left text-info mt-3">
              <div className="col px-0 font-weight-normal">{Common.getBrString(entry_type.info)}</div>
            </div>
          }
        </div>
      </React.Fragment>
    }
    return (
      <div id="user" className="customer-header">
        <div className="customer-text mb-4">
          お客様情報編集
        </div>
        <div className="col bg-white px-0">
          <div>
            {((this.props.page === null || this.props.page === undefined || this.props.page === '') && this.state.setting['CUSTOMER_REG_HEADER']) &&
              <div className="customer-header row mx-0 pt-2 pb-1 text-center">
                <div className="col py-0 px-0 align-self-center">
                  {Common.getBrString(this.state.setting['CUSTOMER_REG_HEADER'])}
                </div>
              </div>
            }
            {(this.props.page === constClass.USER && this.state.setting['CUSTOMER_DISP_HEADER']) &&
              <div className="customer-header row mx-0 pt-2 pb-1 text-center">
                <div className="col py-0 px-0 align-self-center">
                  {Common.getBrString(this.state.setting['CUSTOMER_DISP_HEADER'])}
                </div>
              </div>
            }
            {(this.props.page === constClass.USERCHANGE && this.state.setting['CUSTOMER_CHANGE_HEADER']) &&
              <div className="customer-header row mx-0 pt-2 pb-1 text-center">
                <div className="col py-0 px-0 align-self-center">
                  {Common.getBrString(this.state.setting['CUSTOMER_CHANGE_HEADER'])}
                </div>
              </div>
            }
            <div className="customer-input row mx-0 pt-2 pb-1">
              <div className="col py-0 px-0 align-self-center">
                {renderInput(this.state.setting, 'customer_name', 'text')}
                {renderInput(this.state.setting, 'customer_kana', 'text')}
                {renderInput(this.state.setting, 'gender', 'radio')}
                {renderInput(this.state.setting, 'birth', 'date')}
                {renderInput(this.state.setting, 'phone_number', 'text')}
                {/* <div className='px-1'><button className="btn btn-enable" onClick={() => this.searchPostalCode()}>住所から検索</button></div> */}
                {renderInput(this.state.setting, 'postal_code', 'text')}
                {renderInput(this.state.setting, 'address', 'text')}
                {renderInput(this.state.setting, 'mail_address', 'text')}
                {renderInput(this.state.setting, 'card_id', 'text')}
                {this.state.customer_detail_type.map(t => renderInputDetail(t, Common.getCustomerDetailObject(this.state.my_customer.t_customer_detail), this.changeCustomerDetail))}

              </div>
            </div>
            <React.Fragment>
              {(this.state.setting['ADDITIONAL_AGREEMENT']) &&
                <React.Fragment>
                  <div className="customer-agreement additional-agreement row mx-0 px-3-env py-0 mt-1 mb-1">
                    <div className="col-2">
                      <input type="checkbox" className="form-control" id="agreement" name="agreement" value="true" checked={this.state.my_customer.agreement === constClass.FLAG.ON} onChange={this.changeCustomer}></input>
                    </div>
                    <div className="col-10">
                      <label className="mb-0" htmlFor="agreement">
                        {Common.getBrString(this.state.setting['ADDITIONAL_AGREEMENT'])}
                      </label>
                    </div>
                  </div>
                </React.Fragment>
              }
              {this.state.setting['ADDITIONAL_AGREEMENT_CONTENT'] &&
                <div className="additional-agreement-content row mx-0 px-3-env py-0 mt-1 mb-1">
                  <div className="col" dangerouslySetInnerHTML={{ __html: this.state.setting['ADDITIONAL_AGREEMENT_CONTENT'] }}>
                  </div>
                </div>
              }
            </React.Fragment>

            {this.state.setting['LP_URL'] &&
              <div className="customer-link row mx-0 px-3-env pt-1 pb-2">
                <div className="col text-center">
                  <a href={Common.getExternalUrl(this.state.setting['LP_URL'])} target="_blank" rel="noreferrer"><u>{this.site_name}について</u></a>
                </div>
              </div>
            }
            <div className="customer-submit">
              <div className="col-12 text-center p-0">
                <button
                  disabled={this.checkInvalid() || this.state.disabled}
                  className="button text-black bg-lightwhite"
                  onClick={() => { this.submit() }}>
                  {this.props.page === constClass.REGISTRATIONUSER ? this.state.setting['CUSTOMER_CHANGE_BUTTON'] : this.state.setting['CUSTOMER_REG_BUTTON']}
                </button>
              </div>
              {(this.props.page !== constClass.USERCHANGE && this.state.setting['CUSTOMER_REG_BANNER']) &&
                <div className="col-12 text-center px-0 pt-2">
                  <img src={`/${this.state.siteId}/${this.state.setting['CUSTOMER_REG_BANNER']}`} className="w-100" alt={"バナー"} />
                </div>
              }
              {(this.props.page !== constClass.USERCHANGE && this.state.setting['CUSTOMER_REG_BUTTON_NOTICE']) &&
                <div className="customer-submit-notice row mx-0 px-3-env">
                  <div className="col-12 text-center p-0">
                    <span>{this.state.setting['CUSTOMER_REG_BUTTON_NOTICE']}</span>
                  </div>
                </div>
              }
              {(this.props.page === constClass.USERCHANGE && this.state.setting['CUSTOMER_CHANGE_BUTTON_NOTICE']) &&
                <div className="customer-submit-notice row mx-0 px-3-env">
                  <div className="col-12 text-center p-0">
                    <span>{this.state.setting['CUSTOMER_CHANGE_BUTTON_NOTICE']}</span>
                  </div>
                </div>
              }
              {this.props.page === constClass.REGISTRATIONUSER &&
                <div className="customer-link">
                  <div className="col text-center my-4">
                    <div className='return-saving'
                      disabled={this.state.disabled}
                      onClick={() => { this.resetCustomer(); this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.USERCHANGE}`); this.scrollPageTop(); }}>
                      保存せずに戻る
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCouponList() {
    return (
      <CouponList
        coupon_list={this.state.coupon_list.filter(c => !this.state.ng_coupon_list.includes(c.coupon_id))}//払い出せなかったクーポンを除く
        coupon_codes={this.state.my_customer.m_coupon_code}
        couponClick={(id) => () => this.submitCoupon(id)}
        siteId={this.state.siteId}
        popover_message={this.state.popover_message}
      />
    );
  }
  
  renderFreeTicketList() {
    const unitFreeTicket = [
      ...this.state.ticket_list.filter(ticket =>
        (ticket.mall_id === Number(this.state.mallId) && ticket.ticket_times > 0 && ticket.ticket_type === constClass.FLAG.OFF &&
          Common.isTicketCountAvailable(ticket)) ||
        (ticket.ticket_type === constClass.FLAG.OFF && ticket.ticket_times === 0)
      ),
      ...this.state.ticket_issuelist.filter(t =>
        t.mall_id === Number(this.state.mallId) &&
        t.ticket_type === constClass.FLAG.OFF &&
        (t.use_date === null || t.use_date === '') &&
        t.invalid_flag !== constClass.FLAG.ON
      )
    ];

    const sortedTicket = unitFreeTicket.sort((a, b) => {
      const dateA = new Date(a.ticket_end_date);
      const dateB = new Date(b.ticket_end_date);
      return dateA - dateB;
    });

    if (sortedTicket.length === 0) {
      return (
        <div className="mt-4 text-center">
          現在、利用可能なクーポンはありません
        </div>
      );
    }

    return (
      <div>
        <div className="coupon_list_title">
          クーポン一覧
        </div>
        {sortedTicket.map((ticket, index) => (
          <React.Fragment key={index}>
            {ticket.limit_issue_flag !== constClass.FLAG.ON && !ticket.limit_date ? (
              <TicketList
                key={`ticket-${index}`}
                ticket_list={[ticket]}
                ticketClick={(id) => {
                  this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.FREETICKETUSE}&current_id=${id}`);
                  this.scrollPageTop();
                }}
                siteId={this.state.siteId}
                setting={this.state.setting}
              />
            ) : (
              <TicketIssueList
                key={`issue-${index}`}
                siteId={this.state.siteId}
                ticket_issuelist={[ticket]}
                ticketIssueClick={(count, id) => {
                  this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.FREETICKETISSUEUSE}&current_id=${id}&issue_count=${count}`);
                  this.scrollPageTop();
                }}
                setting={this.state.setting}
              />
            )}
            {index !== sortedTicket.length - 1 && <div className="vector18"></div>}
          </React.Fragment>
        ))}
      </div>
    );
  }

  renderPaidTicketList() {
    const unionPaidTicket = [
      ...this.state.ticket_list.filter(ticket =>
        (ticket.mall_id === Number(this.state.mallId) && ticket.use_point <= this.state.available_point && ticket.ticket_times > 0 && ticket.ticket_type === constClass.FLAG.ON &&
          Common.isTicketCountAvailable(ticket)) ||
        (ticket.use_point <= this.state.available_point && ticket.ticket_type === constClass.FLAG.ON && ticket.ticket_times === 0)
      ),
      ...this.state.ticket_issuelist.filter(t =>
        t.mall_id === Number(this.state.mallId) && t.use_point <= this.state.available_point && t.ticket_type === constClass.FLAG.ON &&
        (t.use_date === null || t.use_date === '') && t.invalid_flag !== constClass.FLAG.ON
      )
    ];
    const sortedTicket = unionPaidTicket.sort((a, b) => a.use_point - b.use_point);
    if (sortedTicket.length === 0) {
      return (
        <div className="mt-4 text-center">
          現在、利用可能なクーポンはありません
        </div>
      );
    }

    return (
      <div>
        {sortedTicket.map((ticket, index) => (
          <React.Fragment key={index}>
            {ticket.limit_issue_flag !== constClass.FLAG.ON && !ticket.limit_date ? (
              <TicketPaidList
                key={`ticket-${index}`}
                ticket_list={[ticket]}
                ticketClick={(id) => {
                  this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.PAIDTICKETUSE}&current_id=${id}`);
                  this.scrollPageTop();
                }}
                siteId={this.state.siteId}
                setting={this.state.setting}
              />
            ) : (
              <TicketIssuePaidList
                key={`issue-${index}`}
                siteId={this.state.siteId}
                ticket_issuelist={[ticket]}
                ticketIssueClick={(count, id) => {
                  this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.PAIDTICKETISSUEUSE}&current_id=${id}&issue_count=${count}`);
                  this.scrollPageTop();
                }}
                setting={this.state.setting}
              />
            )}
            {index !== sortedTicket.length - 1 && <div className="vector18"></div>}
          </React.Fragment>
        ))}
      </div>
    );
  }

  renderInputEntry() {
    return (
      this.props.stampcard_id && this.props.questionnaire_id &&
      <InputEntry
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        shopCode={this.state.shopCode}
        liffAccessToken={this.props.liff_access_token}
        customerId={this.state.my_customer.customer_id}
        entrytypeMaster={this.state.entrytype_master}
        changeOrder={e => this.changeOrder(e)}
        stampcardId={this.props.stampcard_id}
        questionnaireId={this.props.questionnaire_id}
        order={this.state.order}
        ticketClick={() => {
          this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.FREETICKETLIST}`);
          this.ticketBack();
          this.scrollPageTop();
        }}
      />
    );
  }

  renderTicket() {
    return (
      this.props.current_id &&
      <Ticket
        ticket={this.getCurrentTicket()}
        backClick={() => { this.historyBack(); this.ticketBack(); }}
        disabled={this.state.disabled}
        liffAccessToken={this.props.liff_access_token}
        setting={this.state.setting}
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        preview={false}
      />
    );
  }

  renderTicketIssue() {
    return (
      <TicketIssue
        ticket={this.getCurrentTicketIssue()}
        backClick={() => { this.historyBack(); this.ticketBack(); }}
        disabled={this.state.disabled}
        liffAccessToken={this.props.liff_access_token}
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        setting={this.state.setting}
        preview={false}
        ticketButtonClick={(count, id) => () => this.submitTicket(count, id)}
      />
    );
  }

  renderAppLottery() {
    return (
      <React.Fragment>
        {this.state.benefit_lottery_ticket_list.length > 0 &&
          <div className="mt-4 d-flex justify-content-center">
            <div className="text-center flex-column">
              <div className="button text-black bg-lightwhite position-relative">
                {this.state.benefit_lottery_ticket_list.find(x => x.royalty_seen_flag !== constClass.FLAG.ON) &&
                  <i className="bi bi-circle-fill blink-color blink blink-state"></i>
                }
                <Link to={`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.RANKUP}`} className="text-black" ><div>抽選キャンペーン応募はこちら！</div></Link>
              </div>
            </div>
          </div>
        }
        {this.state.lottery_flag && (
          <AppLottery
            siteId={this.state.siteId}
            mallId={this.state.mallId}
            customerId={this.state.my_customer.customer_id}
            disabled={this.state.disabled}
            liffAccessToken={this.props.liff_access_token}
            ticketClick={() => {
              this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.FREETICKETLIST}`);
              this.ticketBack();
              this.scrollPageTop();
            }}
          />
        )}
        {this.state.stamp_master_data && this.state.stamp_master_data.length > 0 && (
          <StampCard
            siteId={this.state.siteId}
            mallId={this.state.mallId}
            shopCode={this.state.shopCode}
            customerId={this.state.my_customer.customer_id}
            lineId={this.state.my_customer.line_id}
            liffAccessToken={this.props.liff_access_token}
            setting={this.state.setting}
            stampRef={this.stampRef}
            ticketClick={() => {
              this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.FREETICKETLIST}`);
              this.ticketBack();
              this.scrollPageTop();
            }}
          />
        )}
        {!this.state.benefit_lottery_ticket_list.length > 0 && !this.state.lottery_flag && (!this.state.stamp_master_data || this.state.stamp_master_data.length === 0) &&
          <div className="event-none-message text-center py-4 px-3 my-4 mx-auto">
            <div className="font-weight-bold mb-2">
              現在開催中のイベントはありません
            </div>
          </div>
        }
      </React.Fragment>
    );
  }

  renderBenefitFinish() {
    return (
      <BenefitFinish
        disabled={this.state.disabled}
        siteId={this.state.siteId}
        backClick={(id) => {
          this.ticketBack();
          this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.MEMBERSHIPPASS}`);
          this.scrollPageTop();
        }}
      />
    );
  }

  renderDeliveryBenefitFinish() {
    return (
      <DeliveryBenefitFinish
        disabled={this.state.disabled}
        siteId={this.state.siteId}
        backClick={(id) => {
          this.ticketBack();
          this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.MEMBERSHIPPASS}`);
          this.scrollPageTop();
        }}
      />
    );
  }

  renderRankUp() {
    return (
      <RankUp
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        shopCode={this.state.shopCode}
        customerId={this.state.my_customer.customer_id}
        liffAccessToken={this.props.liff_access_token}
        benefitClick={(id) => {
          this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.BENEFITUSE}&benefit_id=${id}`);
          this.scrollPageTop();
        }}
        detailClick={(id) => {
          this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.BENEFITUSE}&benefit_id=${id}`);
          this.scrollPageTop();
        }}
        royaltyseenClick={async() => {
          const benefit_lottery_ticket_list_promise =axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${this.state.siteId}/issuelist/`, { customer_id: this.state.my_customer.customer_id, line_id: this.props.liff_access_token, mall_id: this.state.mallId });          
          const benefit_lottery_ticket_list = (await benefit_lottery_ticket_list_promise).data;
          this.setState({
            benefit_lottery_ticket_list
          });
        }}
      />
    );
  }

  renderBenefitUse() {
    return (
      <BenefitUse
        benefitId={this.props.benefit_id}
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        shopCode={this.state.shopCode}
        customerId={this.state.my_customer.customer_id}
        lineId={this.state.my_customer.line_id}
        liffAccessToken={this.props.liff_access_token}
        setting={this.state.setting}
      />
    );
  }

  renderEvent() {
    return (
      this.props.event_uuid &&
      <EventInfoList
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        event={this.state.event}
        eventInfoClick={(checkin_id) => {
          this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.EVENTINFO}&event_uuid=${this.props.event_uuid}&checkin_id=${checkin_id}`);
          this.scrollPageTop();
        }}
        customerId={this.state.my_customer.customer_id}
        liffAccessToken={this.props.liff_access_token}
      />
    );
  }

  renderEventInfo() {
    return (
      this.props.event_uuid && this.props.checkin_id &&
      <EventInfo
        siteId={this.state.siteId}
        event={this.state.event}
        checkinId={this.props.checkin_id}
        backClick={this.historyBack}
      />
    );
  }

  renderStampScan() {
    return (
      <StampScan
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        liffAccessToken={this.props.liff_access_token}
        historyBack={() => this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.APPLOTTERY}`)}
        stamp_uuid={this.props.stamp_uuid}
        stampRef={this.stampRef}
      />
    );
  }

  renderMembershippass() {
    return (
      <MembershipPass
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        shopCode={this.state.shopCode}
        customerId={this.state.my_customer.customer_id}
        lineId={this.state.my_customer.line_id}
        liffAccessToken={this.props.liff_access_token}
        setting={this.state.setting}
        footerHeight={this.state.footerHeight}
        refreshAvailablePoints={() => this.refreshAvailablePoints()}
      />
    );
  }

  renderPointHistory() {
    return (
      <PointHistory
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        customerId={this.state.my_customer.customer_id}
        lineId={this.state.my_customer.line_id}
        liffAccessToken={this.props.liff_access_token}
        setting={this.state.setting}
      />
    );
  }

  renderFirstBonus() {
    return (
      <FirstBonus
        siteId={this.state.siteId}
        mallId={this.state.mallId}
        liffAccessToken={this.props.liff_access_token}
        firstbonus={this.state.firstbonus}
        closeClick={() => this.props.history.replace(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.MEMBERSHIPPASS}`)}
      />
    );
  }

  renderBottom() {
    const tabArray = [];
    if (Common.getFunctionEnabled(this.state.setting, 'MEMBERCARD')) {
      tabArray.push(<div className="col text-center p-0">
        <button
          disabled={this.state.disabled}
          className={`btn btn-submit${([constClass.MEMBERSHIPPASS, constClass.POINTHISTORY, constClass.PAIDTICKETLIST, constClass.PAIDTICKETUSE].includes(this.props.page)) ? '' : '-enable'} ${this.state.mallId === "1" || this.state.mallId === "3" ? '' : 'btn-submit-brown'} w-100 py-2 p-2-env-bottom`}
          onClick={() => { this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.MEMBERSHIPPASS}`); this.scrollPageTop(); }}>
          <div><img className={`icon d-block mx-auto ${this.props.page === constClass.MEMBERSHIPPASS ? 'icon-active' : ''}`} src={WhiteMembershipPassImg} alt="会員証" /></div>
          <div className={this.props.page === constClass.MEMBERSHIPPASS ? 'text-active' : 'text'}>会員証</div>
        </button>
      </div>);
    }
    if (Common.getFunctionEnabled(this.state.setting, 'COUPON')) {
      tabArray.push(<div className="col text-center p-0">
        <button
          disabled={this.state.disabled}
          className={`btn btn-submit${this.props.page === constClass.FREETICKETLIST || this.props.page === constClass.FREETICKETUSE || this.props.page === constClass.FREETICKETISSUEUSE ? '' : '-enable'} ${this.state.mallId === "1" || this.state.mallId === "3" ? '' : 'btn-submit-brown'} w-100 py-2 p-2-env-bottom`}
          onClick={() => { this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.FREETICKETLIST}`); this.refreshData(); this.resetCustomer(); this.scrollPageTop(); }}>
          <div><img className={`icon d-block mx-auto ${this.props.page === constClass.FREETICKETLIST || this.props.page === constClass.FREETICKETUSE || this.props.page === constClass.FREETICKETISSUEUSE ? 'icon-active' : ''}`} src={WhiteTicketImg} alt="チケット" /></div>
          <div className={this.props.page === constClass.FREETICKETLIST || this.props.page === constClass.FREETICKETUSE || this.props.page === constClass.FREETICKETISSUEUSE ? 'text-active' : 'text'}>クーポン</div>
        </button>
      </div>);
    }
    tabArray.push(<div className="col text-center p-0">
      <button
        disabled={this.state.disabled}
        className={`btn btn-submit${this.props.page === constClass.APPLOTTERY ? '' : '-enable'} ${this.state.mallId === "1" || this.state.mallId === "3" ? '' : 'btn-submit-brown'} w-100 py-2 p-2-env-bottom`}
        onClick={() => { this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.APPLOTTERY}`); this.scrollPageTop(); }}>
        <div><img className={`icon d-block mx-auto ${this.props.page === constClass.APPLOTTERY ? 'icon-active' : ''}`} src={WhiteEventImg} alt="イベント" /></div>
        {this.state.benefit_lottery_ticket_list.find(x => x.royalty_seen_flag !== constClass.FLAG.ON) &&
          <i className="bi bi-circle-fill blink-color blink blink-nave-state"></i>
        }
        <div className={this.props.page === constClass.APPLOTTERY ? 'text-active' : 'text'}>イベント</div>
      </button>
    </div>);
    tabArray.push(<div className="col text-center p-0">
      <button
        disabled={this.state.disabled}
        className={`btn btn-submit${this.props.page === constClass.USERCHANGE || this.props.page === constClass.REGISTRATIONUSER ? '' : '-enable'} ${this.state.mallId === "1" || this.state.mallId === "3" ? '' : 'btn-submit-brown'} w-100 py-2 p-2-env-bottom`}
        onClick={() => { this.props.history.push(`/${this.state.siteId}/${this.state.mallId}${this.state.shopCode ? `/shop/${this.state.shopCode}` : ''}/?page=${constClass.USERCHANGE}`); this.scrollPageTop(); }}>
        <div><img className={`icon d-block mx-auto ${this.props.page === constClass.USERCHANGE || this.props.page === constClass.REGISTRATIONUSER ? 'icon-active' : ''}`} src={WhiteMenuImg} alt="メニュー" /></div>
        <div className={this.props.page === constClass.USERCHANGE || this.props.page === constClass.REGISTRATIONUSER ? 'text-active' : 'text'}>メニュー</div>
      </button>
    </div>);

    return (
      <footer className="footer text-center">
        <div className="container m-0 p-0 mw-100" ref={this.footerRef}>
          <div className="row mx-0">
            {([constClass.COUPONLIST, constClass.USER, constClass.USERCHANGE, constClass.FREETICKETLIST, constClass.PAIDTICKETLIST, constClass.FREETICKETUSE, constClass.PAIDTICKETUSE, constClass.MEMBERSHIPPASS, constClass.CONFIRM, constClass.CONFIRM2, constClass.POINTLIST, constClass.FREETICKETISSUEUSE, constClass.PAIDTICKETISSUEUSE, constClass.REGISTRATIONUSER, constClass.TERMS, constClass.POINTHISTORY, constClass.HELP, constClass.RANKUP, constClass.BENEFITUSE, constClass.BENEFITGRANTUSE, constClass.APPLOTTERY, constClass.EVENT, constClass.EVENTINFO, constClass.BENEFITFINISH, constClass.DELIVERYBENEFITFINISH, constClass.INPUTENTRY, constClass.STAMPSCAN].includes(this.props.page)) && (
              <div className="col text-center p-0">
                <div className={`row mx-0 fotter ${this.state.lottery_flag === constClass.FLAG.ON ? 'footer-tab-5' : 'footer-tab-4'}`}>
                  {tabArray.map((tab, idx) =>
                    <React.Fragment key={idx}>
                      {tab}
                    </React.Fragment>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </footer>
    );
  }

  render() {
    return (
      <React.Fragment>
        <DocumentMeta {...this.meta} />
        {this.state.ready ? <div className={`liff-top ${((this.props.event_uuid && this.props.page === constClass.EVENT) || (this.props.event_uuid && this.props.checkin_id && this.props.page === constClass.EVENTINFO)) ? 'bg-black' : 'bg-lightwhite'}`} style={{ '--header-height': `${this.state.headerHeight}px`, '--footer-height': `${this.state.footerHeight}px` }}>
          <ScrollToTop />
          <div className={`page-${(this.props.page === undefined || this.props.page === null || this.props.page === '' || this.props.page === constClass.PAYMENT) ? 'full' : 'btn'}`} ref={this.pageRef}>
            {(this.props.page === constClass.CONFIRM || this.props.page === constClass.CONFIRM2) &&
              <div>
                {this.state.campaign &&
                  <Liffconfirm
                    {...this.props} {...{ condition: { campaign: this.state.campaign, my_customer: this.state.my_customer, my_entry: this.state.my_entry, setting: this.state.setting } }}
                  />
                }
                {!this.state.campaign && <Loading />}
              </div>
            }
            {(this.props.page === undefined || this.props.page === null || this.props.page === '') &&
              this.renderTerms(false)
            }
            {this.props.page === constClass.TERMS &&
              this.renderTerms(true)
            }
            {this.props.page === constClass.MEMBERSHIPPASS &&
              this.renderMembershippass()
            }
            {this.props.page === constClass.STAMPSCAN &&
              this.renderStampScan()
            }
            {this.props.page === constClass.STAMPCHECK &&
              this.renderStampCheck()
            }
            {this.props.page === constClass.POINTHISTORY &&
              this.renderPointHistory()
            }
            {this.props.page === constClass.COUPONLIST &&
              this.renderCouponList()
            }
            {this.props.page === constClass.USER &&
              this.renderUser(true)
            }
            {this.props.page === constClass.USERCHANGE &&
              this.renderUser(false)
            }
            {this.props.page === constClass.REGISTRATIONUSER &&
              this.renderRegistrationUser()
            }
            {this.props.page === constClass.FREETICKETLIST &&
              this.renderFreeTicketList()
            }
            {this.props.page === constClass.PAIDTICKETLIST &&
              this.renderPaidTicketList()
            }
            {this.props.page === constClass.FREETICKETUSE &&
              this.renderTicket()
            }
            {this.props.page === constClass.FREETICKETISSUEUSE &&
              this.renderTicketIssue()
            }
            {this.props.page === constClass.PAIDTICKETUSE &&
              this.renderTicket()
            }
            {this.props.page === constClass.PAIDTICKETISSUEUSE &&
              this.renderTicketIssue()
            }
            {this.props.page === constClass.FIRSTBONUS &&
              this.renderFirstBonus()
            }
            {this.props.page === constClass.HELP &&
              this.renderHelp()
            }
            {this.props.page === constClass.RANKUP &&
              this.renderRankUp()
            }
            {this.props.page === constClass.BENEFITUSE &&
              this.renderBenefitUse()
            }
            {this.props.page === constClass.BENEFITGRANTUSE &&
              this.renderBenefit()
            }
            {this.props.page === constClass.BENEFITFINISH &&
              this.renderBenefitFinish()
            }
            {this.props.page === constClass.DELIVERYBENEFITFINISH &&
              this.renderDeliveryBenefitFinish()
            }
            {this.props.page === constClass.APPLOTTERY &&
              this.renderAppLottery()
            }
            {this.props.page === constClass.EVENT &&
              this.renderEvent()
            }
            {this.props.page === constClass.EVENTINFO &&
              this.renderEventInfo()
            }
            {this.props.page === constClass.INPUTENTRY &&
              this.renderInputEntry()
            }
          </div>
          {this.state.setting['HIDE_FOOTER'] !== constClass.FLAG.ON && this.props.page !== constClass.USER && this.renderBottom()}
          {this.state.disabled && <Loading />}
          <Modal isOpen={(this.state.setting && "MODAL_SERVICE_STOP_MESSAGE" in this.state.setting && this.state.setting["MODAL_SERVICE_STOP_MESSAGE"].length > 1)} style={{ ...this.modalStyle, overlay: { ...this.modalStyle.overlay, backgroundColor: 'rgba(0, 0, 0, 1)' } }}>
            <div className="container-fluid section-white m-0 py-2 vh-50 overflow-auto">
              <div className="row mx-0 px-3-env text-left form-group">
                <div className="col px-0 align-self-center text-center">
                  <span>お知らせ</span>
                </div>
              </div>
              <div className="row mx-0 px-3-env mt-3 mb-2 text-left">
                <div className="col px-0 align-self-center">{Common.getBrString(this.state.setting["MODAL_SERVICE_STOP_MESSAGE"])}</div>
              </div>
              <div className="row mx-0 px-3-env mt-2 mb-3 text-left">
                <div className="col px-0 align-self-center"></div>
              </div>
            </div>
          </Modal>
          <Modal isOpen={(this.state.cancel_modal_flag)} style={this.modalStyle}>
            <div className="container-fluid section-white m-0 py-2 vh-50 overflow-auto">
              <div className="row mx-0 px-3-env text-left form-group">
                <div className="col px-0 align-self-center">
                  <span>アカウント停止のお知らせ</span>
                </div>
              </div>
              <div className="row mx-0 px-3-env mt-3 mb-2 text-left">
                <div className="col px-0 align-self-center">お客様の会員アプリの利用は停止されました。</div>
              </div>
              <div className="row mx-0 px-3-env mt-2 mb-3 text-left">
                <div className="col px-0 align-self-center"></div>
              </div>
            </div>
          </Modal>
        </div>
          : this.state.siteId ? <Loading /> : <Loading />}
      </React.Fragment>
    )
  }
}

export default withRouter(Liff);